<div style="padding:30px">
    <app-check-permissions [data]="'zwVU'">
        <div style="text-align: center;">
            經紀範圍：
            <select class="form-control vlist"
                *ngIf="vendor_type_list.length>1"
                [(ngModel)]="vtype"
                (change)="pageobj.page=0;check_list_init_list()"
            >
                <option *ngFor="let item of vendor_type_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
        </div>
        <hr>
    </app-check-permissions>
    <div class="top d-xl-flex" >
        <select class="form-control vlist"
            *ngIf="vendor_list.length>1"
            [(ngModel)]="vid"
            (change)="pageobj.page=0;check_init_list()"
        >
            <option *ngFor="let item of vendor_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <button
            *ngIf="now_vinfo.code"
            style="height: 40px;
            margin-top: 0;" class="btn btn-info allset"
            data-toggle="modal" data-target=".bd-example-modal-xl"
            (click)="all_edit()"
        >
            全部設定
        </button>
        <button
            *ngIf="!now_vinfo.code"
            style="height: 40px;
            margin-top: 0;" class="btn btn-info allset text-nowrap"
            data-toggle="modal" data-target=".bd-example-modal-xl"
            (click)="cfd_serial()"
        >
            CFD序號
        </button>
        <a href="{{urltoken4}}" style="height:40px" *ngIf="urltoken4.length>0&&!now_vinfo.code" target="_blank"  class="btn btn-success text-nowrap">年度提領清冊</a>
        <app-check-permissions [data]="'zwVU'">
            <label class="btn btn-success text-nowrap" style="height:40px">
                更新提領狀態
                <input type="file" (change)="upload($event)" accept=".xlsx,.csv" style="display:none">
            </label>
        </app-check-permissions>
        <!--<a  href="{{urltoken}}" style="height:40px" *ngIf="urltoken.length>0&&now_vinfo.code" target="_blank"  class="btn btn-success">匯出上次提領試算</a>-->
        <app-check-permissions [data]="'zwVU'">
            <a  href="{{urltoken7}}" style="height:40px" target="_blank"  class="btn btn-success text-nowrap">經濟領現匯款單</a>
        </app-check-permissions>
        <div class="code_info" *ngIf="now_vinfo.code">
            <div class="input-text">
                <input type="text" id="social_input" [(ngModel)]="now_vinfo.code" disabled>
                <i class="fa fa-copy" (click)="copyToClipboard(now_vinfo.code)"></i>
            </div>
            <div style="margin-top: 4px;text-align: center;" class="tips">點選複製推薦碼</div>
        </div>
        <div class="d-flex align-items-center">
            <label for="date">選擇時間：</label>
            <input type="date" id="date" name="date" [(ngModel)]="selectedDateTime" [min]="minDate" [max]="maxDate" required *ngIf="dayOfMonth >= 1 && dayOfMonth <= 10">
            <input type="date" id="date" name="date"  [(ngModel)]="selectedDateTime" required disabled="disabled" *ngIf="dayOfMonth >10">
        </div>
        <button style="height: 40px; margin-top: 0;" class="btn btn-info allset text-nowrap" (click)="setTime(1)" *ngIf="dayOfMonth >= 1 && dayOfMonth <=10">送出</button>
        <div class="d-flex align-items-center">
            <label class="text-nowrap">提領狀態： </label>
            <div class="text-nowrap" *ngIf="withdrawal_changes == '0'" [ngStyle]="{'color': 'red'}">核實金額中</div>
            <div class="text-nowrap" *ngIf="withdrawal_changes == '1'" [ngStyle]="{'color': '#fbb328'}">處理付款中</div>
            <div class="text-nowrap" *ngIf="withdrawal_changes == '2'" [ngStyle]="{'color': 'green'}">本月提領完成</div>
        </div>
        <app-check-permissions [data]="'sXQy'">
            <button style="height: 40px; margin-top: 0;" class="btn btn-info allset text-nowrap" (click)="setTime(2)" *ngIf="withdrawal_changes != '2'">更改狀態</button>
        </app-check-permissions>
    </div>

<!-- ///// -->
    <app-check-permissions [data]="'zwVU'">
        <div class="vendor-selection-container">
            <!-- 收起/展開標題區 -->
            <div class="toggle-header" (click)="toggleExpanded()" *ngIf="vid == '-1'">
                <h4 class="mb-0">
                    <i class="fas" [ngClass]="isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    選擇經紀操作
                    <span class="vendor-count" *ngIf="selectedVendors.length > 0">(已選擇 {{selectedVendors.length}} 個)</span>
                </h4>
            </div>

            <!-- 經紀選擇區域 -->
            <div class="selection-panel" *ngIf="isExpanded">
                <div class="panel-content">
                    <!-- 全選/取消全選 -->
                    <div class="select-all-controls mb-3">
                        <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="selectAll()" style="margin-right: 10px;">
                            全選
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearAll()" style="margin-right: 10px;">
                            取消全選
                        </button>
                        <span class="ms-3 text-muted">已選擇: {{selectedVendors.length}} / {{getSelectableVendors().length}}</span>
                    </div>

                    <!-- 經紀清單 -->
                    <div class="vendor-list">
                        <div class="row">
                            <div class="col-md-6 col-lg-4 mb-2" *ngFor="let vendor of getSelectableVendors()">
                                <div class="form-check vendor-item">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        [id]="'vendor-' + vendor.id"
                                        [value]="vendor.id"
                                        (change)="onVendorChange($event, vendor)"
                                        [checked]="isSelected(vendor.id)">
                                    <label class="form-check-label" [for]="'vendor-' + vendor.id">
                                        <div class="vendor-info">
                                            <div class="vendor-name">{{vendor.name}}</div>
                                            <div class="vendor-code">{{vendor.code}}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 選擇摘要 -->
                    <div class="selected-summary mt-3" *ngIf="selectedVendors.length > 0">
                        <small class="text-muted">已選擇的經紀：</small>
                        <div class="selected-tags">
                            <span class="badge bg-primary me-1 mb-1" *ngFor="let vendor of getSelectedVendorDetails()" style="margin-right: 10px;">
                                {{vendor.name}}
                                <button type="button" class="btn-close btn-close-white ms-1"
                                    (click)="removeVendor(vendor.id)"
                                    aria-label="移除"
                                    style="font-size: 0.7em;">
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 操作按鈕區域 -->
            <div class="action-buttons mt-4" *ngIf="selectedVendors.length > 0">
                <div class="alert alert-info">
                    <i class="fas fa-info-circle me-2"></i>
                    請選擇要執行的操作，將對以下 {{selectedVendors.length}} 個經紀進行處理
                </div>
                <div class="alert alert-warning mb-3" *ngIf="isProcessing">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span>
                            <i class="fas fa-spinner fa-spin me-2"></i>
                            正在處理第 <strong>{{currentProgress}}</strong> / <strong>{{totalProgress}}</strong> 個廠商...
                        </span>
                        <span class="badge bg-primary fs-6">{{getProgressPercent()}}%</span>
                    </div>

                    <div class="progress mb-2" style="height: 25px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                             role="progressbar"
                             [style.width.%]="getProgressPercent()"
                             [attr.aria-valuenow]="currentProgress"
                             [attr.aria-valuemin]="0"
                             [attr.aria-valuemax]="totalProgress">
                            <strong>{{currentProgress}} / {{totalProgress}}</strong>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
                        <small class="text-muted">
                            <i class="fas fa-clock me-1"></i>
                            預計剩餘時間: <strong>{{getRemainingTime()}}</strong> 秒
                        </small>
                        <small class="text-muted">
                            <i class="fas fa-hourglass-half me-1"></i>
                            已用時間: <strong>{{getElapsedTime()}}</strong> 秒
                        </small>
                    </div>
                </div>

                <div class="button-group">
                    <button (click)="getUrlWithParams('urltoken2')"
                        style="height:40px; margin-left: 5px;"
                        class="btn btn-success">
                        <i class="fas fa-file-invoice me-2"></i>勞務報酬單
                    </button>

                    <button (click)="getUrlWithParams('urltoken5')"
                        style="height:40px; margin-left: 5px;"
                        class="btn btn-success">
                        <i class="fas fa-hand-holding-usd me-2"></i>勞務報酬單(領現)
                    </button>

                    <button (click)="getUrlWithParams('urltoken6')"
                        style="height:40px; margin-left: 5px;"
                        class="btn btn-success">
                        <i class="fas fa-receipt me-2"></i>領現單
                    </button>

                    <button (click)="getUrlWithParams('urltoken3')"
                        style="height:40px; margin-left: 5px;"
                        class="btn btn-success">
                        <i class="fas fa-money-check me-2"></i>會計匯款單
                    </button>
                </div>
            </div>

            <!-- 未選擇提示 -->
            <div class="no-selection-alert mt-4" *ngIf="selectedVendors.length === 0 && isExpanded == true">
                <div class="alert alert-warning">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    請先選擇至少一個經紀才能執行操作
                </div>
            </div>
        </div>
    </app-check-permissions>

<!-- //// -->

    <!-- <app-check-permissions [data]="'zwVU'">
        <a  href="{{urltoken2}}" style="height:40px; margin-left: 5px;" target="_blank"  class="btn btn-success" *ngIf="status_man == true"   >勞務報酬單</a>
        <a  href="{{urltoken5}}" style="height:40px; margin-left: 5px;" target="_blank"  class="btn btn-success" *ngIf="status_man == true"   >勞務報酬單(領現)</a>
        <a  href="{{urltoken6}}" style="height:40px; margin-left: 5px;" target="_blank"  class="btn btn-success" *ngIf="status_man == true"   >領現單</a>
        <a  href="{{urltoken3}}" style="height:40px; margin-left: 5px;" target="_blank"  class="btn btn-success" *ngIf="status_man == true"   >會計匯款單</a>
    </app-check-permissions> -->
    <div class="card text-white bg-light mb-3 info_item" style="margin-top:10px" *ngIf="(now_vinfo.all||active_info) && now != '9'">
        <div class="card-header">區間加總</div>
        <div class="card-body" *ngIf="sublist_now=='0' && now_vinfo.all">
            <p class="card-text">一般鑽石：{{now_vinfo.all.general_diamond|number}}鑽</p>
            <p class="card-text">活動鑽石：{{now_vinfo.all.active_diamond|number}}鑽</p>
            <p class="card-text">預估經紀分潤：{{now_vinfo.all.money|number}}元</p>
            <p class="tips">此為粗估數字具體收益已該期報表為主</p>
            <p class="tips">(僅用選取區間的鑽石*0.068)</p>
            <p class="card-text">平均每日營業額目標 : {{daily_income.target_money}}元</p>
            <p class="card-text">現有營業額 : {{daily_income.money}}元</p>
        </div>
        <div class="card-body" *ngIf="sublist_now=='1'">
            <p class="card-text">在線時長:{{active_info.login_time}}</p>
            <p class="card-text">訊息數(送):{{active_info.text_num|number}}</p>
            <p class="card-text">訊息數(收):{{active_info.get_text_num|number}}</p>
            <p class="card-text">動態數:{{active_info.story_num|number}}</p>
            <p class="card-text">語音時間:{{active_info.voice_time}}</p>
            <p class="card-text">視訊時間:{{active_info.video_time}}</p>
            <p class="card-text">遊戲時間:{{active_info.game_time}}</p>
        </div>
    </div>
    <div class="card text-white bg-light mb-3 info_item" style="margin-top:10px" *ngIf=" now == '9'">
        <div class="card-header">區間加總</div>
        <div class="card-body">
            <p class="card-text">總收益：{{total.total_income|number}}</p>
            <p class="card-text">文字收益：{{total.text_income|number}}</p>
            <p class="card-text">語音收益：{{total.voice_income|number}}</p>
            <p class="card-text">視訊收益：{{total.video_income|number}}</p>
            <p class="card-text">相簿收益：{{total.album_income|number}}</p>
            <p class="card-text">遊戲收益：{{total.game_income|number}}</p>
            <p class="card-text">活動獎勵：{{total.active_reward|number}}</p>
            <p class="card-text">禮物收益：{{total.gift_reward|number}}</p>
            <p class="card-text">直播收益：{{total.live_reward|number}}</p>
            <p class="card-text">約會收益：{{total.date_reward|number}}</p>
            <p class="card-text">語音房收益：{{total.voice_room_income|number}}</p>
            <p class="card-text">聊天室紅包收益：{{total.donate_income|number}}</p>
            <p class="card-text">其他收益：{{total.other|number}}</p>
        </div>
    </div>

    <!-- 壽星區塊 -->
    <div class="birthday-section">
        <div class="birthday-card">
            <!-- 標題列（可收合） -->
            <div class="birthday-header" (click)="birthday_collapsed = !birthday_collapsed">
                <div class="birthday-title">
                    <i class="fas fa-birthday-cake"></i>
                    <span>本周壽星</span>
                    <span class="birthday-week-label">{{ birthday_week }}</span>
                    <span class="badge badge-danger ml-2" *ngIf="birthday_count > 0">{{ birthday_count }} 位</span>
                    <span class="badge badge-warning ml-1" *ngIf="birthday_marked_count > 0">
                        <i class="fas fa-tag" style="font-size:10px;"></i> {{ birthday_marked_count }} 標記送禮
                    </span>
                    <span class="badge badge-success ml-1" *ngIf="birthday_sent_count > 0">
                        <i class="fas fa-check-circle" style="font-size:10px;"></i> {{ birthday_sent_count }} 已送禮
                    </span>
                </div>
                <i class="fas" [ngClass]="birthday_collapsed ? 'fa-chevron-down' : 'fa-chevron-up'" style="color:#999;font-size:13px;cursor:pointer;"></i>
            </div>

            <div *ngIf="!birthday_collapsed">
                <!-- 工具列 -->
                <div class="birthday-toolbar">
                    <div class="bd-toolbar-left">
                        <div class="bd-date-wrap">
                            <label><i class="fas fa-calendar-alt mr-1"></i>業績區間</label>
                            <app-date [time]="bd_time" [timeset]="bd_timeset" (rangeSelected)="bd_handleRangeSelected($event)"></app-date>
                        </div>
                        <div class="bd-sort-wrap">
                            <label><i class="fas fa-search mr-1"></i>搜尋</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="bd_search_keyword" placeholder="名稱 / UID / 電話" style="width:160px;">
                        </div>
                        <div class="bd-sort-wrap">
                            <label><i class="fas fa-filter mr-1"></i>獎勵狀態</label>
                            <select class="form-control form-control-sm" [(ngModel)]="bd_filter_reward" style="width:120px;">
                                <option value="">全部</option>
                                <option value="0">初始</option>
                                <option value="1">標記送禮</option>
                                <option value="2">已送禮</option>
                            </select>
                        </div>
                        <div class="bd-sort-wrap">
                            <label><i class="fas fa-sort-amount-down mr-1"></i>排序</label>
                            <div class="bd-sort-group">
                                <select class="form-control form-control-sm" [(ngModel)]="birthday_sort_field" style="width:100px;">
                                    <option value="birthday">生日</option>
                                    <option value="income">業績</option>
                                    <option value="name">名稱</option>
                                </select>
                                <button class="btn btn-sm btn-outline-secondary bd-dir-btn" (click)="birthday_sort_dir = birthday_sort_dir === 'asc' ? 'desc' : 'asc'" [title]="birthday_sort_dir === 'asc' ? '小→大（點擊切換）' : '大→小（點擊切換）'">
                                    <i class="fas" [ngClass]="birthday_sort_dir === 'asc' ? 'fa-sort-amount-up' : 'fa-sort-amount-down'"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="bd-toolbar-right">
                        <div class="btn-group btn-group-sm mr-2">
                            <button class="btn" [ngClass]="birthday_view === 'card' ? 'btn-primary' : 'btn-outline-secondary'" (click)="birthday_view='card'" title="卡片檢視">
                                <i class="fas fa-th-large"></i>
                            </button>
                            <button class="btn" [ngClass]="birthday_view === 'table' ? 'btn-primary' : 'btn-outline-secondary'" (click)="birthday_view='table'" title="表格檢視">
                                <i class="fas fa-list"></i>
                            </button>
                        </div>
                        <button class="btn btn-sm btn-outline-warning" (click)="batch_mark_all()"
                                *ngIf="birthday_list.length > 0 && birthday_marked_count + birthday_sent_count < birthday_count"
                                title="將所有初始狀態壽星標記送禮">
                            <i class="fas fa-tag mr-1"></i>全部標記送禮
                        </button>
                    </div>
                </div>

                <!-- 內容區 -->
                <div class="birthday-body">
                    <div *ngIf="birthday_loading" class="text-center py-4">
                        <i class="fas fa-spinner fa-spin fa-lg"></i>
                        <span class="ml-2 text-muted">載入中...</span>
                    </div>

                    <div *ngIf="!birthday_loading && birthday_list.length === 0" class="text-center text-muted py-4">
                        <i class="fas fa-birthday-cake fa-2x mb-2" style="opacity:.2"></i>
                        <p class="mb-0">此區間沒有壽星</p>
                    </div>

                    <!-- 卡片檢視 -->
                    <div *ngIf="!birthday_loading && birthday_list.length > 0 && birthday_view === 'card'" class="birthday-grid">
                        <div class="birthday-member" *ngFor="let b of birthday_list"
                             [class.birthday-today]="b.is_today" [class.birthday-rewarded]="b.reward_status === 2" [class.birthday-marked]="b.reward_status === 1">
                            <div class="birthday-avatar-wrap">
                                <img loading="lazy" [src]="b.profile_pic" class="birthday-avatar"
                                     onerror="this.src='https://chatmate.tw/img/default.png'">
                                <span class="birthday-date-badge" [class.today-badge]="b.is_today">
                                    {{ b.birthday_md }}
                                    <i *ngIf="b.is_today" class="fas fa-star" style="font-size:9px;color:#ffc107;margin-left:2px;"></i>
                                </span>
                                <span class="bd-reward-check" *ngIf="b.reward_status === 1" style="color:#f0932b;"><i class="fas fa-tag"></i></span>
                                <span class="bd-reward-check" *ngIf="b.reward_status === 2" style="color:#28a745;"><i class="fas fa-check-circle"></i></span>
                            </div>
                            <div class="birthday-info">
                                <div class="birthday-name">
                                    <app-userandactive [post]="b"></app-userandactive>
                                </div>
                                <div class="birthday-meta">
                                    <span class="bd-birthday-tag">
                                        <i class="fas fa-birthday-cake" style="font-size:10px;"></i> {{ b.birthday_md }}
                                        <span *ngIf="b.is_today" class="bd-today-text">今天!</span>
                                    </span>
                                    <span class="birthday-vendor"><i class="fas fa-building"></i> {{ b.v_name }}</span>
                                    <span [ngClass]="get_online_class(b.is_online)">
                                        <i class="fas fa-circle" style="font-size:7px;"></i> {{ get_online_label(b.is_online) }}
                                    </span>
                                </div>
                                <div class="birthday-bottom">
                                    <div class="birthday-income">
                                        <i class="fas fa-gem"></i>
                                        <span>{{ b.total_income | number }}</span>
                                    </div>
                                    <div class="bd-reward-btns">
                                        <button *ngIf="b.reward_status === 0" class="btn btn-sm bd-reward-btn btn-outline-warning"
                                                (click)="set_reward_status(b, 1)" title="標記送禮">
                                            <i class="fas fa-tag"></i>
                                            <span class="d-none d-md-inline ml-1">標記送禮</span>
                                        </button>
                                        <button *ngIf="b.reward_status === 1" class="btn btn-sm bd-reward-btn btn-warning text-white"
                                                (click)="set_reward_status(b, 2)" title="確認已送禮">
                                            <i class="fas fa-gift"></i>
                                            <span class="d-none d-md-inline ml-1">確認送禮</span>
                                        </button>
                                        <button *ngIf="b.reward_status === 1" class="btn btn-sm bd-reward-btn btn-outline-secondary ml-1"
                                                (click)="set_reward_status(b, 0)" title="退回初始">
                                            <i class="fas fa-undo"></i>
                                        </button>
                                        <span *ngIf="b.reward_status === 2" class="badge badge-success" style="font-size:12px; padding:5px 10px;">
                                            <i class="fas fa-check-circle mr-1"></i>已送禮
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 表格檢視 -->
                    <div *ngIf="!birthday_loading && birthday_list.length > 0 && birthday_view === 'table'">
                        <table class="table table-hover table-sm mb-0 birthday-table">
                            <thead>
                                <tr>
                                    <th style="width:40px">#</th>
                                    <th style="width:55px">大頭貼</th>
                                    <th>名稱</th>
                                    <th class="text-center bd-sortable-th" (click)="bd_toggle_sort('birthday')">
                                        生日
                                        <i class="fas" style="font-size:11px;"
                                           [ngClass]="birthday_sort_field === 'birthday' ? (birthday_sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"
                                           [style.color]="birthday_sort_field === 'birthday' ? '#667eea' : '#ccc'"></i>
                                    </th>
                                    <th>經紀</th>
                                    <th class="text-center">在線</th>
                                    <th class="text-right bd-sortable-th" (click)="bd_toggle_sort('income')">
                                        業績 (鑽)
                                        <i class="fas" style="font-size:11px;"
                                           [ngClass]="birthday_sort_field === 'income' ? (birthday_sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"
                                           [style.color]="birthday_sort_field === 'income' ? '#667eea' : '#ccc'"></i>
                                    </th>
                                    <th class="text-center" style="width:180px">獎勵狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let b of birthday_list; let i = index"
                                    [class.birthday-today]="b.is_today" [class.birthday-sent-row]="b.reward_status === 2" [class.birthday-marked-row]="b.reward_status === 1">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        <img loading="lazy" [src]="b.profile_pic" class="bd-table-avatar"
                                             onerror="this.src='https://chatmate.tw/img/default.png'">
                                    </td>
                                    <td>
                                        <app-userandactive [post]="b"></app-userandactive>
                                    </td>
                                    <td class="text-center">
                                        <span class="bd-table-date">{{ b.birthday_md }}</span>
                                        <i *ngIf="b.is_today" class="fas fa-star ml-1" style="color:#ffc107;font-size:11px;"></i>
                                    </td>
                                    <td>{{ b.v_name }}</td>
                                    <td class="text-center">
                                        <span [ngClass]="get_online_class(b.is_online)">
                                            <i class="fas fa-circle mr-1" style="font-size:7px;"></i>{{ get_online_label(b.is_online) }}
                                        </span>
                                    </td>
                                    <td class="text-right font-weight-bold" style="color:#667eea;">{{ b.total_income | number }}</td>
                                    <td class="text-center" style="white-space:nowrap;">
                                        <button *ngIf="b.reward_status === 0" class="btn btn-sm bd-reward-btn btn-outline-warning"
                                                (click)="set_reward_status(b, 1)" title="標記送禮">
                                            <i class="fas fa-tag mr-1"></i>標記送禮
                                        </button>
                                        <button *ngIf="b.reward_status === 1" class="btn btn-sm bd-reward-btn btn-warning text-white"
                                                (click)="set_reward_status(b, 2)" title="確認已送禮">
                                            <i class="fas fa-gift mr-1"></i>確認送禮
                                        </button>
                                        <button *ngIf="b.reward_status === 1" class="btn btn-sm bd-reward-btn btn-outline-secondary ml-1"
                                                (click)="set_reward_status(b, 0)" title="退回初始">
                                            <i class="fas fa-undo"></i>
                                        </button>
                                        <span *ngIf="b.reward_status === 2" class="badge badge-success" style="font-size:12px; padding:5px 10px;"
                                              [title]="'操作者：' + (b.reward_by || '') + ' ' + (b.reward_dt || '')">
                                            <i class="fas fa-check-circle mr-1"></i>已送禮
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- 底部統計 -->
                <div class="birthday-footer" *ngIf="!birthday_loading && birthday_list.length > 0">
                    <span class="text-muted small">
                        共 {{ birthday_count }} 位壽星，標記送禮 {{ birthday_marked_count }} 位，已送禮 {{ birthday_sent_count }} 位
                    </span>
                    <span class="text-muted small">
                        業績區間：{{ bd_income_start }} ~ {{ bd_income_end }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer" (click)="choose(item.id)">
            <span [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <span *ngIf="now=='0' || now == '1' || now == '4' || now == '5'"  style="display:flex">
        <div *ngIf="now == '4'" style="display: flex;align-items: center;">
            開始月份
            <input [(ngModel)]="current_month" type="month" id="start_month" name="start_month" min="2023-01"  />
            結束月份
            <input [(ngModel)]="current_monthed" type="month" id="end_month" name="end_month"  />
        </div>
        <div *ngIf="now == '5'" style="display: flex;align-items: center;">
            <input [(ngModel)]="current_month" type="month" id="start_month" name="start_month" min="2023-01"  />
        </div>
        <input type="text" [(ngModel)]="search_model" class="form-control fix_input search_inp" placeholder="可輸入名稱搜尋用戶" (keyup.enter)="init_list()">
        <div style="display:flex;align-items: center;">
            <select class="form-control vlist"
                *ngIf="now == '0'"
                [(ngModel)]="search_status"
            >
                <option value="">狀態不限</option>
                <option value="1">正常</option>
                <option value="0">鎖定</option>
                <option value="-1">解除代理關係</option>
                <option value="-2">關閉自動退出</option>
                <option value="-3">用戶停權</option>
            </select>
            <select class="form-control vlist"
                *ngIf="now == '0'"
                [(ngModel)]="search_lv"
            >
                <option value="">等級不限</option>
                <option value="1">等級 1</option>
                <option value="2">等級 2</option>
                <option value="3">等級 3</option>
                <option value="4">等級 4</option>
                <option value="5">等級 5</option>
                <option value="6">等級 6</option>
            </select>
            <span *ngIf="now == '0'">
                大於n天沒上線<input type="number" [(ngModel)]="search_offline_day" id="offline_day" name="offline_day" style="width: 50px;display:inline-block" />
            </span>
            <select class="form-control vlist"
                *ngIf="now == '4' || now == '5'"
                [(ngModel)]="search_trasnfer_status"
                >
                <option disabled value="99">請選擇狀態</option>
                <option value="0">不限</option>
                <option value="2">累計未匯</option>
                <option value="1">正常</option>
                <option value="-1">鎖定</option>
                <option value="5">領現</option>
            </select>
            <select class="form-control vlist" *ngIf="now == '4'" [(ngModel)]="search_health_fee">
                <option value="">不限</option>
                <option value="1">不需扣健保費</option>
            </select>
            <select class="form-control vlist" *ngIf="now == '4'" [(ngModel)]="search_account_memo">
                <option value="">不限</option>
                <option value="1">會計有備註</option>
            </select>
            <select class="form-control vlist" *ngIf="now == '4'" [(ngModel)]="search_withdrawal_status">
                <option value="-1">不限</option>
                <option value="0">未付款</option>
                <option value="1">已付款</option>
                <option value="2">付款失敗</option>
            </select>
            <button style="margin-left: 10px;"class="btn btn-primary" (click)="init_list()">搜尋</button>
        </div>
    </span>
    <div *ngIf="now=='0'">
        <r-table [data]="posts_input"  (callback)="init_list()">
            <ng-template let-post #operation_dk>
                <span *ngIf="post.key=='name'">
                    <div *ngIf="vendor_list.length>=1">
                        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                    </div>
                    <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                </span>
                <span *ngIf="post.key=='os_type'">
                    <div>{{data[post.idx].os_type==1?'Andorid':'iOS'}}</div>
                </span>
                <span *ngIf="post.key=='is_hidden'">
                    <div>{{data[post.idx].is_hidden==1?'是':'否'}}</div>
                </span>
                <span *ngIf="post.key=='auto_remove'">
                    <div>{{data[post.idx].auto_remove==1?'是':'否'}}</div>
                    <div *ngIf="data[post.idx].auto_remove==0" >{{data[post.idx].pass_auto_remove_start_dt}} ~</div>
                    <div *ngIf="data[post.idx].auto_remove==0" >{{data[post.idx].pass_auto_remove_end_dt}}</div>
                </span>
                <span *ngIf="post.key=='link'">
                    <div class="code_info">
                        <div class="input-text">
                            <input type="text" id="social_input" [(ngModel)]="data[post.idx].name" disabled>
                            <i class="fa fa-copy" (click)="createlink(data[post.idx])"></i>
                        </div>
                        <div style="margin-top: 4px;text-align: center;" class="tips">點選複製個人資料連結</div>
                    </div>
                </span>
                <span *ngIf="post.key=='studio'">
                    <span *ngIf="data[post.idx].is_studio==1" class="badge badge-warning" style="font-size:13px">工作室</span>
                    <div *ngIf="data[post.idx].is_studio==1 && data[post.idx].studio_name" class="small text-muted">{{data[post.idx].studio_name}}</div>
                    <span *ngIf="data[post.idx].is_studio!=1" class="badge badge-light" style="font-size:13px">個人戶</span>
                </span>
                <span *ngIf="post.key=='opt'">
                    <div style="display:flex">
                        <a href="javascript:void(0)" title="點我設定"  (click)="subnow='0';edit_data=data[post.idx];edit_data.user_vid = edit_data.vid " data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                        </a>
                        <a href="javascript:void(0)" title="登入明細"  (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin: 0 10px 0 0;" class="fas fa-door-closed"></i>
                        </a>
                        <app-check-permissions [data]="'ExcM'">
                            <a href="javascript:void(0)" title="提領設定"  (click)="subnow='9';edit_data=data[post.idx];checkdata();" data-toggle="modal" data-target=".bd-example-modal-xl">
                                <i style="margin: 0 10px 0 0;" class="fas fa-book"></i>
                            </a>
                        </app-check-permissions>
                            <a *ngIf="data[post.idx]?.status != -1" href="javascript:void(0)" title="試算薪資" (click)="calmoney(edit_data=data[post.idx])">
                                <i style="margin: 0 10px 0 0;" class="fas fa-money-bill-alt"></i>
                            </a>
                            <a href="javascript:void(0)" title="點我設定"  (click)="edit_pro(data[post.idx])">
                                <i style="margin-right:10px" class="fas fa-solid fa-pen" ></i>
                            </a>
                    </div>
                </span>
            </ng-template>
            <ng-template let-post #operation_mb>
                <span *ngIf="post.key=='name'">
                    <div *ngIf="vendor_list.length>=1">
                        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                    </div>
                    <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                </span>
                <span *ngIf="post.key=='os_type'">
                    <div>{{data[post.idx].os_type==1?'Andorid':'iOS'}}</div>
                </span>
                <span *ngIf="post.key=='is_hidden'">
                    <div>{{data[post.idx].is_hidden==1?'是':'否'}}</div>
                </span>
                <span *ngIf="post.key=='auto_remove'">
                    <div>{{data[post.idx].auto_remove==1?'是':'否'}}</div>
                    <div *ngIf="data[post.idx].auto_remove==0" >{{data[post.idx].pass_auto_remove_start_dt}} ~</div>
                    <div *ngIf="data[post.idx].auto_remove==0" >{{data[post.idx].pass_auto_remove_end_dt}}</div>
                </span>
                <span *ngIf="post.key=='studio'">
                    <span *ngIf="data[post.idx].is_studio==1" class="badge badge-warning" style="font-size:13px">工作室</span>
                    <div *ngIf="data[post.idx].is_studio==1 && data[post.idx].studio_name" class="small text-muted">{{data[post.idx].studio_name}}</div>
                    <span *ngIf="data[post.idx].is_studio!=1" class="badge badge-light" style="font-size:13px">個人戶</span>
                </span>
                <span *ngIf="post.key=='opt'">
                    <div style="display:flex">
                        <a href="javascript:void(0)" title="點我設定"  (click)="subnow='0';edit_data=data[post.idx]" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                        </a>
                        <a href="javascript:void(0)" title="登入明細"  (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin: 0 10px 0 0;" class="fas fa-door-closed"></i>
                        </a>
                        <app-check-permissions [data]="'ExcM'">
                            <a href="javascript:void(0)" title="提領設定"  (click)="subnow='9';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                                <i style="margin: 0 10px 0 0;" class="fas fa-book"></i>
                            </a>
                            <a href="javascript:void(0)" *ngIf="data[post.idx]?.status != -1" title="試算薪資" (click)="calmoney(edit_data=data[post.idx])">
                                <i style="margin: 0 10px 0 0;" class="fas fa-money-bill-alt"></i>
                            </a>
                        </app-check-permissions>
                    </div>
                </span>
            </ng-template>
        </r-table>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
    </div>
    <div *ngIf="now=='1'">
        <r-table [data]="posts_input" (callback)="init_list()">
            <ng-template let-post #operation_dk>
                <span *ngIf="post.key=='name'">
                    <div *ngIf="vendor_list.length>=1">
                        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                    </div>
                    <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                </span>
                <span *ngIf="post.key=='now_round_diamond'">
                    <span *ngIf="data[post.idx].now_round_diamond==0">0</span>
                    <a
                        *ngIf="data[post.idx].now_round_diamond>0"
                        (click)="view_round(data[post.idx],1);"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].now_round_diamond|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='last_round_diamond'">
                    <span *ngIf="data[post.idx].last_round_diamond==0">0</span>
                    <a (click)="view_round(data[post.idx],2);"
                        *ngIf="data[post.idx].last_round_diamond>0"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].last_round_diamond|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='total_money'">
                    <span *ngIf="data[post.idx].total_money==0">0</span>
                    <a (click)="view_each_round(data[post.idx])"
                        *ngIf="data[post.idx].total_money>0"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].total_money|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='opt'">
                    <a href="javascript:void(0)" title="點我設定"  (click)="subnow='0';edit_data=data[post.idx]" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                    </a>
                    <a href="javascript:void(0)" title="登入明細"  (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-door-closed"></i>
                    </a>
                </span>
            </ng-template>
            <ng-template let-post #operation_mb>
                <span *ngIf="post.key=='name'">
                    <div *ngIf="vendor_list.length>=1">
                        <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                    </div>
                    <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                </span>
                <span *ngIf="post.key=='now_round_diamond'">
                    <span *ngIf="data[post.idx].now_round_diamond==0">0</span>
                    <a
                        *ngIf="data[post.idx].now_round_diamond>0"
                        (click)="view_round(data[post.idx],1);"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].now_round_diamond|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='last_round_diamond'">
                    <span *ngIf="data[post.idx].last_round_diamond==0">0</span>
                    <a (click)="view_round(data[post.idx],2);"
                        *ngIf="data[post.idx].last_round_diamond>0"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].last_round_diamond|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='total_money'">
                    <span *ngIf="data[post.idx].total_money==0">0</span>
                    <a (click)="view_each_round(data[post.idx])"
                        *ngIf="data[post.idx].total_money>0"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl">
                        {{data[post.idx].total_money|number}}
                    </a>
                </span>
                <span *ngIf="post.key=='opt'">
                    <a href="javascript:void(0)" title="點我設定"  (click)="subnow='0';edit_data=data[post.idx]" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                    </a>
                    <a href="javascript:void(0)" title="登入明細"  (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-door-closed"></i>
                    </a>
                </span>
            </ng-template>
        </r-table>
    </div>
    <div *ngIf="now=='2' && edit_data">
        <div class="user_edit_block">
            輸入電話號碼:
            <div>
                <input type="number" [(ngModel)]="edit_data.phone_num" class="form-control fix_input" >
                <button type="button"  (click)="ck_phone()"   class="btn btn-primary" data-dismiss="modal">檢查</button>
                <div *ngIf="edit_data.name && edit_data.name.length>0">姓名:{{edit_data.name}}</div>
                <div *ngIf="edit_data.name && edit_data.name.length>0"> 圖片:<img loading="lazy" style="height: 60px;" [src]="edit_data.profile_pic"></div>
            </div>
            <button *ngIf="edit_data.name && edit_data.name.length>0"  style="margin:10px"  (click)="add_user()" class="btn btn-danger" data-dismiss="modal">確認</button>
        </div>
   </div>
    <div *ngIf="now=='3'">
        <div  style="width: 240px;">
            <input type="text"
                class="form-control"
                ngxDaterangepickerMd
                [(ngModel)]="time"
                [autoApply]="true"
                [ranges]="ranges" [alwaysShowCalendars]="true"
                [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                [opens]="'right'"
                [minDate]="time.minDate"
                [maxDate]='time.maxDate'
                (change)="onRangeSelected($event)"
                (blur)="onDateTyped($event)">
        </div>
        <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
            <li *ngFor="let item of sub_menu_list;let i = index" class="nav-item"  style="cursor:pointer" (click)="sub_choose(item.id)">
                <span [ngClass]="sublist_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
            </li>
        </ul>
        <div  *ngIf="sublist_now == '1'">
            <r-table [data]="posts_input" (callback)="init_list()">
                <ng-template let-post #operation_dk>
                    <span *ngIf="post.key=='name'">
                        <div *ngIf="vendor_list.length>=1">
                            <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                        </div>
                        <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                    </span>
                </ng-template>
                <ng-template let-post #operation_mb>
                    <span *ngIf="post.key=='name'">
                        <div *ngIf="vendor_list.length>=1">
                            <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                        </div>
                        <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                    </span>
                </ng-template>
            </r-table>
            <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
        </div>
    </div>

    <div *ngIf="now=='4'">
        <r-table [data]="posts_input"  (callback)="init_list()">
            <ng-template let-post #operation_dk>
                <span *ngIf="post.key=='general_money'">
                    <a href="javascript:void(0)" data-toggle="modal" data-target=".bd-example-modal-xl" (click)="show_diamond_detail(data[post.idx].memo[0],data[post.idx])">{{data[post.idx].general_money}}</a>
                </span>
                <span *ngIf="post.key=='pre_cut_active'">
                    <div>{{(data[post.idx].pre_cut_active)*0.068}}</div>
                </span>
                <span *ngIf="post.key=='baccount'">
                    <a href="javascript:void(0)" data-toggle="modal" data-target=".bd-example-modal-xl" (click)="show_accounting_memo(data[post.idx])">{{data[post.idx].baccount}}</a>
                    <div>{{data[post.idx].memo[0].accounting_memo}}</div>
                </span>
                <span *ngIf="post.key=='actual_withdrawal_status'">
                    <button  *ngIf="data[post.idx].actual_withdrawal_status == 0" [ngClass]="data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 0?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 0)" class="btn" style="margin-right:1%">尚未付款</button>
                    <button  *ngIf="(data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 1 || data[post.idx].actual_withdrawal_status == 2)" [ngClass]="data[post.idx].actual_withdrawal_status == 1 || data[post.idx].actual_withdrawal_status == 1?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 1)" class="btn" style="margin-right:1%">付款成功</button>
                    <button  *ngIf="(data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 2)" [ngClass]="data[post.idx].actual_withdrawal_status == 2 || data[post.idx].actual_withdrawal_status == 2?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 2)" class="btn" style="margin-right:1%">付款失敗</button>
                </span>
                <div *ngIf="post.key == 'actual_withdrawal_time' && (data[post.idx].transfer_status == 1 || data[post.idx].transfer_status == 5 )">
                    <select class="form-control vlist"  [(ngModel)]="data[post.idx].actual_withdrawal_time" (change)="set_withdrawal_time_status(data[post.idx])" *ngIf="isYearSelectable(data[post.idx].actual_withdrawal_time) == true" >
                        <option disabled value="">請選擇月份</option>
                        <option *ngFor="let item of withdrawal_month_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <div  *ngIf="isYearSelectable(data[post.idx].actual_withdrawal_time) == false" >
                        {{data[post.idx].actual_withdrawal_time}}
                    </div>
                </div>
                <span *ngIf="post.key=='opt'">
                    <span *ngIf="data[post.idx].transfer_status == 3 || data[post.idx].transfer_status == 4">
                        <span *ngIf="data[post.idx].transfer_status == 3">累積未匯</span>
                        <span *ngIf="data[post.idx].transfer_status == 4">累積已匯</span>
                    </span>
                    <span *ngIf="data[post.idx].transfer_status != 3 && data[post.idx].transfer_status != 4">
                        <button [ngClass]="data[post.idx].transfer_status == 1 || data[post.idx].transfer_status == 2?'btn-primary':'btn-secondary'" (click)="set_banktransfer_status(data[post.idx], 1)" class="btn" >匯款</button>
                        <button [ngClass]="data[post.idx].transfer_status == 5?'btn-primary':'btn-secondary'" (click)="set_banktransfer_status(data[post.idx], 5)" class="btn" style="margin-left: 1%;">領現</button>
                        <!-- <button [ngClass]="data[post.idx].transfer_status == -1?'btn-danger':'btn-secondary'"  (click)="set_banktransfer_status(data[post.idx], -1)" class="btn" style="margin-left: 1%;" >鎖定</button> -->
                    </span>
                </span>
                <span *ngIf="post.key=='gg'">
                    <div style="display:flex">
                        <a href="javascript:void(0)" title="點我設定"  (click)="edit_pro(data[post.idx])">
                            <i style="margin-right:10px" class="fas fa-solid fa-pen" ></i>
                        </a>
                    </div>
                </span>
            </ng-template>
            <ng-template let-post #operation_mb>
                <span *ngIf="post.key=='actual_withdrawal_status'">
                    <button  *ngIf="data[post.idx].actual_withdrawal_status == 0" [ngClass]="data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 0?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 0)" class="btn" style="margin-right:1%">尚未付款</button>
                    <button  *ngIf="(data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 1 || data[post.idx].actual_withdrawal_status == 2)" [ngClass]="data[post.idx].actual_withdrawal_status == 1 || data[post.idx].actual_withdrawal_status == 1?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 1)" class="btn" style="margin-right:1%">付款成功</button>
                    <button  *ngIf="(data[post.idx].actual_withdrawal_status == 0 || data[post.idx].actual_withdrawal_status == 2)" [ngClass]="data[post.idx].actual_withdrawal_status == 2 || data[post.idx].actual_withdrawal_status == 2?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(data[post.idx], 2)" class="btn" style="margin-right:1%">付款失敗</button>
                </span>

                <div *ngIf="post.key == 'actual_withdrawal_time' && (data[post.idx].transfer_status == 1 || data[post.idx].transfer_status == 5 )">
                    <select class="form-control vlist" [(ngModel)]="data[post.idx].actual_withdrawal_time"  (change)="set_withdrawal_time_status(data[post.idx])"  *ngIf="isYearSelectable(data[post.idx].actual_withdrawal_time) == true" >
                        <option disabled value="">請選擇月份</option>
                        <option *ngFor="let item of withdrawal_month_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <div  *ngIf="isYearSelectable(data[post.idx].actual_withdrawal_time) == false" >
                        {{data[post.idx].actual_withdrawal_time}}
                    </div>
                </div>

                <span *ngIf="post.key=='opt'">
                    <span *ngIf="data[post.idx].transfer_status == 3 || data[post.idx].transfer_status == 4">
                        <span *ngIf="data[post.idx].transfer_status == 3">累積未匯</span>
                        <span *ngIf="data[post.idx].transfer_status == 4">累積已匯</span>
                    </span>
                    <span *ngIf="data[post.idx].transfer_status != 3 && data[post.idx].transfer_status != 4">
                        <button [ngClass]="data[post.idx].transfer_status == 1 || data[post.idx].transfer_status == 2?'btn-primary':'btn-secondary'" (click)="set_banktransfer_status(data[post.idx], 1)" class="btn" >匯款</button>
                        <button [ngClass]="data[post.idx].transfer_status == 5?'btn-primary':'btn-secondary'" (click)="set_banktransfer_status(data[post.idx], 5)" class="btn" style="margin-left: 1%;" >領現</button>
                        <!-- <button [ngClass]="data[post.idx].transfer_status == -1?'btn-danger':'btn-secondary'"  (click)="set_banktransfer_status(data[post.idx], -1)" class="btn"  style="margin-left: 1%;">鎖定</button> -->
                    </span>
                </span>
                <span *ngIf="post.key=='gg'">
                    <div style="display:flex">
                        <a href="javascript:void(0)" title="點我設定"  (click)="edit_pro(data[post.idx])">
                            <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                        </a>
                    </div>
                </span>
            </ng-template>
        </r-table>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
    </div>
    <div *ngIf="now=='5'">
        <r-table [data]="posts_input"  (callback)="init_list()">
            <ng-template let-post #operation_dk>
            </ng-template>
            <ng-template let-post #operation_mb>
            </ng-template>
        </r-table>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
    </div>
    <div
        *ngIf="edit_data"
        class="modal fade bd-example-modal-xl" tabindex="-1"
        role="dialog"  data-keyboard="false" data-backdrop="static"
        aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
        style="max-height: 680px;overflow:auto;"
    >
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="subnow=='0'">設定</h5>
                    <h5 class="modal-title" *ngIf="subnow=='1'">登入紀錄</h5>
                    <h5 class="modal-title" *ngIf="subnow=='2'">鑽石明細</h5>
                    <h5 class="modal-title" *ngIf="subnow=='3'">全部設定 <div class="tips">本設定會直接影響所有成員</div></h5>
                    <h5 class="modal-title" *ngIf="subnow=='4'">各期資訊 </h5>
                    <!-- <button type="button" *ngIf="subnow=='5'"  class="btn btn-primary" (click)="serial_add()">新增用戶</button> -->
                    <input type="text" *ngIf="subnow=='5'" [(ngModel)]="search_serial" class="form-control fix_input search_inp" placeholder="搜尋用戶" (keyup.enter)="cfd_serial()">
                    <h5 class="modal-title" *ngIf="subnow=='7'">當期鑽石明細 </h5>
                    <h5 class="modal-title" *ngIf="subnow=='8'">會計備註 </h5>
                    <h5 class="modal-title" *ngIf="subnow=='9' && diamond_type == 0">提領設定</h5>
                    <h5 class="modal-title" *ngIf="subnow=='9' && diamond_type == 1">鑽石設定</h5>
                    <h5 class="modal-title" *ngIf="subnow=='9' && diamond_type == 2">匯率設定</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <!-- Modal body -->
                <div style="padding: 10px;">
                    <div *ngIf="subnow=='0'">
                        <!-- <div class="user_edit_block">
                            推薦分數:  <input type="number" min="1" max="9" [(ngModel)]="edit_data.sort_score" class="form-control fix_input" >
                        </div> -->
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">大頭貼</label>
                            <img loading="lazy" style="height: 100px;" [src]="edit_data.profile_pic">
                            <button (click)="edit_data.profile_pic=iconPic" style="margin: 10px;" class=" btn-danger btn" >預設</button>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">是否潛水</label>
                            <button (click)="edit_data.is_hidden='1'"  [ngClass]="edit_data.is_hidden=='1'?'btn-success':'btn-secondary'"  class="btn  m5">是</button>
                            <button (click)="edit_data.is_hidden='0'"  [ngClass]="edit_data.is_hidden=='0'?'btn-success':'btn-secondary'"  class="btn  m5">否</button>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">帳號狀態</label>
                            <button (click)="edit_data.status='1'"  [ngClass]="edit_data.status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">啟用</button>
                            <button (click)="edit_data.status='0'"  [ngClass]="edit_data.status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">鎖定</button>
                            <button (click)="edit_data.status='-1'"  [ngClass]="edit_data.status=='-1'?'btn-success':'btn-secondary'"  class="btn  m5">移除</button>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">提領方式</label>
                            <button (click)="edit_data.withdrawal_method='0'"  [ngClass]="edit_data.withdrawal_method=='0'?'btn-success':'btn-secondary'"  class="btn  m5">匯款</button>
                            <button (click)="edit_data.withdrawal_method='1'"  [ngClass]="edit_data.withdrawal_method=='1'?'btn-success':'btn-secondary'"  class="btn  m5">領現</button>
                        </div>
                        <!-- 工作室身分：set_vendor.php type=4 只在有帶 is_studio / studio_name 時才寫（isset 守衛），沒點過就不會動到原值 -->
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">身分</label>
                            <button (click)="edit_data.is_studio='0'"  [ngClass]="edit_data.is_studio!='1'?'btn-success':'btn-secondary'"  class="btn  m5">個人戶</button>
                            <button (click)="edit_data.is_studio='1'"  [ngClass]="edit_data.is_studio=='1'?'btn-success':'btn-secondary'"  class="btn  m5">工作室</button>
                            <input *ngIf="edit_data.is_studio=='1'" type="text" [(ngModel)]="edit_data.studio_name" maxlength="100" class="form-control fix_input" placeholder="工作室名稱（100 字內）" style="display:inline-block;width:220px;margin-left:5px;">
                            <div class="tips col-sm-2 col-form-label">工作室成員不列入一般對帳／勞報單／匯款單，改到「經紀公司人員(工作室)」處理（每期收發票、核實後才放款）</div>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">經紀名稱</label>
                            <select class="form-control vlist"
                                    *ngIf="all_vendor_list.length>1"
                                    [(ngModel)]="edit_data.user_vid"
                            >
                                <option default disabled value="-2">請選擇經紀名稱</option>
                                <option *ngFor="let item of all_vendor_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">計算方式</label>
                            <button (click)="edit_data.method_type='3'"  [ngClass]="edit_data.method_type=='3'?'btn-success':'btn-secondary'"  class="btn  m5">預設</button>
                            <!--<button (click)="edit_data.method_type='2'"  [ngClass]="edit_data.method_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">自訂</button>   -->
                            <div class="tips col-sm-2 col-form-label">預設將以經紀匯率的百分比進行計算</div>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">等級</label>
                            <input type="number" min="1"  [(ngModel)]="edit_data.lv" class="form-control fix_input" >
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">自動退出經紀</label>
                            <button (click)="edit_data.auto_remove='1'"  [ngClass]="edit_data.auto_remove=='1'?'btn-success':'btn-secondary'"  class="btn  m5">啟用</button>
                            <button (click)="edit_data.auto_remove='0'"  [ngClass]="edit_data.auto_remove=='0'?'btn-success':'btn-secondary'"  class="btn  m5">關閉</button>
                            <span *ngIf="edit_data.auto_remove=='0'" >
                                起:<input type="date" [(ngModel)]="edit_data.pass_auto_remove_start_dt"> ~ 迄:<input type="date" [(ngModel)]="edit_data.pass_auto_remove_end_dt">
                            </span>
                            <div class="tips col-sm-2 col-form-label">30天沒上線，自動退出</div>
                        </div>
                        <div class="user_edit_block form-group" *ngIf="edit_data.method_type=='2'">
                            <label class="col-sm-2 col-form-label">薪資級距</label>
                            <button (click)="edit_data.salary_type='0'"  [ngClass]="edit_data.salary_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">關閉</button>
                            <!-- <button (click)="edit_data.salary_type='1'"  [ngClass]="edit_data.salary_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">實領獎金</button> -->
                            <button (click)="edit_data.salary_type='2'"  [ngClass]="edit_data.salary_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">抽成比例</button>
                        </div>
                        <div class="user_edit_block form-group"  *ngIf="edit_data.method_type=='2'">
                            <label class="col-sm-2 col-form-label">獎金級距</label>
                            <button (click)="edit_data.bonus_type='0'"  [ngClass]="edit_data.bonus_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">關閉</button>
                            <button (click)="edit_data.bonus_type='1'"  [ngClass]="edit_data.bonus_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">實領獎金</button>
                            <!-- <button (click)="edit_data.bonus_type='2'"  [ngClass]="edit_data.bonus_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">抽成比例</button>     -->
                        </div>
                        <div class="user_edit_block form-group"  *ngIf="edit_data.method_type=='2' && edit_data.salary_type=='0' && edit_data.bonus_type=='0'">
                            <div class="tips">
                                此設定將導致人員扣款且拿不到收益
                            </div>
                        </div>

                    </div>
                    <div *ngIf="subnow=='1'">
                        <ul  *ngIf="edit_data.length!=0">
                            <li *ngFor="let item of edit_data; let key = index; trackBy: trackByFn" style="list-style: none;">
                                {{item.date}}日 登入次數:{{item.times}}次
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="subnow=='2' ">
                        <div *ngIf="subnow_menu_data.length>0">
                            開始日期:
                            <select class="form-control" style="width: 260px;display: inline-block;" [(ngModel)]="subnow_menu">
                                <option *ngFor="let item of subnow_menu_data" [ngValue]="item.id">{{item.name}}</option>
                            </select>

                            <table class="table table-responsive-sm" >
                                <thead>
                                    <tr class="table-secondary" style="font-size:18px;">
                                        <th style="width:5%">名目</th>
                                        <th style="width:5%">鑽石數</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>文字收入</td>
                                        <td>{{edit_data.data[subnow_menu].text_income|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>語音收入</td>
                                        <td>{{edit_data.data[subnow_menu].voice_income|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>視訊收入</td>
                                        <td>{{edit_data.data[subnow_menu].video_income|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>解鎖動態收入</td>
                                        <td>{{edit_data.data[subnow_menu].album_income|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>禮物收入</td>
                                        <td>{{edit_data.data[subnow_menu].gift_reward|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>活動收入</td>
                                        <td>{{edit_data.data[subnow_menu].active_reward|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>其他</td>
                                        <td>{{edit_data.data[subnow_menu].other|number}}</td>
                                    </tr>
                                    <tr>
                                        <td>總鑽石數</td>
                                        <td>{{edit_data.info[subnow_menu].total|number}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div *ngIf="edit_data.data[subnow_menu].deposit">
                                保留鑽石數：{{edit_data.data[subnow_menu].deposit|number}}
                                <span class="tips">未必會使用</span>
                            </div>
                        </div>
                        <div *ngIf="subnow_menu_data.length==0">
                            無資料
                        </div>
                    </div>
                    <div *ngIf="subnow=='3'">
                        <div class="user_edit_block">
                            <label class="col-sm-2 col-form-label">是否潛水</label>
                            <button (click)="edit_data.is_hidden='1'"  [ngClass]="edit_data.is_hidden=='1'?'btn-success':'btn-secondary'"  class="btn  m5">是</button>
                            <button (click)="edit_data.is_hidden='0'"  [ngClass]="edit_data.is_hidden=='0'?'btn-success':'btn-secondary'"  class="btn  m5">否</button>
                        </div>
                        <!-- <div class="user_edit_block">
                            <label class="col-sm-2 col-form-label">未達最低提領門檻則鑽石是否歸零</label>
                            <button (click)="edit_data.pre_recount_status='1'"  [ngClass]="edit_data.pre_recount_status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">是</button>
                            <button (click)="edit_data.pre_recount_status='0'"  [ngClass]="edit_data.pre_recount_status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">否</button>
                            <div class="tips">本設定由下期生效</div>
                        </div> -->
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">計算方式</label>
                            <button (click)="edit_data.method_type='3'"  [ngClass]="edit_data.method_type=='3'?'btn-success':'btn-secondary'"  class="btn  m5">預設</button>
                            <button (click)="edit_data.method_type='2'"  [ngClass]="edit_data.method_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">級距制</button>
                            <div class="tips col-sm-2 col-form-label">非級距制將以經紀匯率的百分比進行計算</div>
                        </div>
                        <div class="user_edit_block form-group" *ngIf="edit_data.method_type=='2'">
                            <label class="col-sm-2 col-form-label">薪資級距</label>
                            <button (click)="edit_data.salary_type='0'"  [ngClass]="edit_data.salary_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">關閉</button>
                            <!-- <button (click)="edit_data.salary_type='1'"  [ngClass]="edit_data.salary_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">實領獎金</button> -->
                            <button (click)="edit_data.salary_type='2'"  [ngClass]="edit_data.salary_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">抽成比例</button>
                        </div>
                        <div class="user_edit_block form-group"  *ngIf="edit_data.method_type=='2'">
                            <label class="col-sm-2 col-form-label">獎金級距</label>
                            <button (click)="edit_data.bonus_type='0'"  [ngClass]="edit_data.bonus_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">關閉</button>
                            <button (click)="edit_data.bonus_type='1'"  [ngClass]="edit_data.bonus_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">實領獎金</button>
                            <!-- <button (click)="edit_data.bonus_type='2'"  [ngClass]="edit_data.bonus_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">抽成比例</button>     -->
                        </div>
                        <div class="user_edit_block form-group"  *ngIf="edit_data.method_type=='2' && edit_data.salary_type=='0' && edit_data.bonus_type=='0'">
                            <div class="tips">
                                此設定將導致人員扣款且拿不到收益
                            </div>
                        </div>
                    </div>
                    <div *ngIf="subnow=='4'">
                        <table class="table table-responsive-sm show_dk_data" >
                            <thead>
                                <tr class="table-secondary" style="font-size:18px;">
                                    <th style="width:5%">起始日</th>
                                    <th style="width:5%">結算日</th>
                                    <th style="width:5%">一般收入(總)</th>
                                    <th style="width:5%">活動收入(總)</th>
                                    <th style="width:5%">獎金收入(總)</th>
                                    <th style="width:5%">總收入</th>
                                    <th style="width:5%">扣除鑽石(總)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-light" style="font-size:18px;">
                                    <td>{{round_info.start_dt}}</td>
                                    <td>{{round_info.end_dt}}</td>
                                    <td>{{round_info.general_money|number}}</td>
                                    <td>{{round_info.active_money|number}}</td>
                                    <td>{{round_info.bonus_money|number}}</td>
                                    <td>{{round_info.total|number}}</td>
                                    <td>{{round_info.spent_diamond|number}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="modal-body show_dk_data">
                            <thead>
                                <tr  class="table-primary" style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                                    <th style="width:5%">起始日</th>
                                    <th style="width:5%">結算日</th>
                                    <th style="width:5%">一般收入</th>
                                    <th style="width:5%">活動收入</th>
                                    <th style="width:5%">獎金收入</th>
                                    <th style="width:5%">總收入</th>
                                    <th style="width:5%">扣除鑽石</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of edit_data; let key = index; trackBy: trackByFn"  style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                                    <td>{{item.start_dt}}</td>
                                    <td>{{item.end_dt}}</td>
                                    <td>{{item.general_money|number}}元</td>
                                    <td>{{item.active_money|number}}元</td>
                                    <td>{{item.bonus_money|number}}元</td>
                                    <td>{{item.total|number}}元</td>
                                    <td>{{item.spent_diamond|number}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="card-deck">
                            <div class="card show_mb_data">
                                <!-- <img loading="lazy" class="card-img-top" src="..." alt="Card image cap"> -->
                                <div class="card-body" style="    background: #00bcd4; font-weight: 600;">
                                    <h5 class="card-title">各期加總</h5>
                                    <div class="card-text show_mb_item">
                                        <div>起始日：</div>
                                        <div>{{round_info.start_dt}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>結算日：</div>
                                        <div>{{round_info.end_dt}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>一般收入(總)：</div>
                                        <div>{{round_info.general_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>活動收入(總)：</div>
                                        <div>{{round_info.active_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>獎金收入(總)：</div>
                                        <div>{{round_info.bonus_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>總收入：</div>
                                        <div>{{round_info.total|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>扣除鑽石(總)：</div>
                                        <div>{{round_info.spent_diamond|number}}</div>
                                    </div>
                                    <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
                                </div>
                            </div>
                            <div class="card show_mb_data" *ngFor="let item of edit_data; let key = index; trackBy: trackByFn">
                                <!-- <img loading="lazy" class="card-img-top" src="..." alt="Card image cap"> -->
                                <div class="card-body">
                                    <!-- <h5 class="card-title">{{item.name}}({{item.rank}})</h5> -->
                                    <div class="card-text show_mb_item">
                                        <div>起始日：</div>
                                        <div>{{item.start_dt}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>結算日：</div>
                                        <div>{{item.end_dt}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>一般收入：</div>
                                        <div>{{item.general_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>活動收入：</div>
                                        <div>{{item.active_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>獎金收入：</div>
                                        <div>{{item.bonus_money|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>總收入：</div>
                                        <div>{{item.total|number}}</div>
                                    </div>
                                    <div class="card-text show_mb_item">
                                        <div>扣除鑽石：</div>
                                        <div>{{item.spent_diamond|number}}</div>
                                    </div>
                                    <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
                                </div>
                            </div>
                        </div>
                        <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation>
                    </div>
                    <div *ngIf="subnow=='5'">
                        <r-table [data]="serial_input">
                            <!-- <ng-template let-post #operation_dk>
                                <span *ngIf="post.key=='opt'">
                                    <a href="javascript:void(0)" title="修改"  (click)="serial_edit(serial_data[post.idx])">
                                        <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                                    </a>
                                    <a href="javascript:void(0)" title="刪除"  (click)="serial_remove(serial_data[post.idx])">
                                        <i style="margin-right:10px" class="fas fa-trash" ></i>
                                    </a>
                                </span>
                            </ng-template>
                            <ng-template let-post #operation_mb>
                                <span *ngIf="post.key=='opt'">
                                    <a href="javascript:void(0)" title="修改"  (click)="serial_edit(serial_data[post.idx])">
                                        <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                                    </a>
                                    <a href="javascript:void(0)" title="刪除"  (click)="serial_remove(serial_data[post.idx])">
                                        <i style="margin-right:10px" class="fas fa-trash" ></i>
                                    </a>
                                </span>
                            </ng-template> -->
                        </r-table>
                        <app-pagnation (callback)="serial_callback($event)"  [data]="serial_pageobjstr"></app-pagnation>
                    </div>

                    <div *ngIf="subnow=='6'">
                        <div *ngIf="edit_serial_data.id">修改</div>
                        <div *ngIf="!edit_serial_data.id">新增</div>
                        <input *ngIf="edit_serial_data.id" type="text" [(ngModel)]="edit_serial_data.serial" class="form-control " placeholder="序號" >
                        <input type="text" [(ngModel)]="edit_serial_data.name" class="form-control " placeholder="姓名" >
                        <input type="text" [(ngModel)]="edit_serial_data.id_no" class="form-control " placeholder="身份證" >
                        <input type="text" [(ngModel)]="edit_serial_data.addr" class="form-control " placeholder="戶籍" >
                        <input type="text" [(ngModel)]="edit_serial_data.memo" class="form-control " placeholder="備註" >
                        <input type="text" [(ngModel)]="edit_serial_data.phone_num" class="form-control " placeholder="手機號碼(請填帳號)" >
                    </div>

                    <div *ngIf="subnow=='7'">
                        <div>文字收益: {{memo.data.text_income}}</div>
                        <div>語音收益: {{memo.data.voice_income}}</div>
                        <div>視訊收益: {{memo.data.video_income}}</div>
                        <div>解鎖收益: {{memo.data.album_income}}</div>
                        <div>遊戲收益: {{memo.data.game_income}}</div>
                        <div>禮物收益: {{memo.data.gift_reward}}</div>
                        <div>約會收益: {{memo.data.date_reward}}</div>
                        <div>直播收益: {{memo.data.live_reward}}</div>
                        <div>語音房收益: {{memo.data.voice_room_income}}</div>
                        <div>抖內收益: {{memo.data.donate_income}}</div>
                        <div>其他收益: {{memo.data.other}}</div>
                        <div>--------------------------</div>
                        <div>除活動外總收益: {{memo.caculate.general_diamond - diamond_detail.extra_diamond }}</div>
                        <div>匯率: {{memo.caculate.salary_rank.ratio}}</div>
                        <div>轉換成現金: {{memo.caculate.general_money - (diamond_detail.extra_diamond * diamond_detail.extra_exchange_rate) }}</div>
                        <div>--------------------------</div>
                        <div>活動收益: {{memo.data?.active_reward || 0}}</div>
                        <div>預扣活動鑽石: {{ memo.data?.pre_cut_active || 0 }}</div>
                        <div>匯率: {{ active_rate(diamond_detail) }}</div>
                        <div>轉換成現金: {{ ((memo.data?.active_reward * 1 || 0) + (memo.data?.pre_cut_active * 1 || 0)) * active_rate(diamond_detail) }}</div>
                        <div>--------------------------</div>
                        <div>預扣鑽石: {{memo.data.pre_cut_diamond}}</div>
                        <div>匯率: {{diamond_detail.extra_exchange_rate}}</div>
                        <div>轉換成現金: {{memo.caculate.pre_cut_money}}</div>
                        <div>--------------------------</div>
                        <div>額外鑽石: {{diamond_detail.extra_diamond}}</div>
                        <div>匯率:{{diamond_detail.extra_exchange_rate}}</div>
                        <div>轉換成現金: {{diamond_detail.extra_diamond * diamond_detail.extra_exchange_rate}}</div>
                        <div>--------------------------</div>
                        <div *ngIf="memo.accumulation_reason">未匯原因: {{memo.accumulation_reason}}</div>
                    </div>

                    <div *ngIf="subnow=='8'">
                        <input type="text" [(ngModel)]="accounting_memo" class="form-control " placeholder="會計備註" >
                    </div>
                    <div *ngIf="subnow=='9' && diamond_type == 0">
                        <div class="diamond_data">
                            <div style="display: flex;justify-content: center;">
                                <h4  style="margin-right: 1%;">鑽石調整</h4>
                                <i class="fas fa-plus" style="cursor: pointer;align-content: center;color: cadetblue;" (click)="add_diamond()"></i>
                            </div>
                            <div>
                                <app-table-v2  *ngIf="diamond_data.length>0" [type]="1" [tcontent]="tcontent_diamond" [data]="diamond_data">
                                    <ng-template let-post #operation_dk>
                                        <div *ngIf="post.key == 'gg'">
                                            <a href="javascript:void(0)" title="刪除"  (click)="del(1,post.idx);">
                                                <i style="margin: 0 10px 0 0;" class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </ng-template>
                                </app-table-v2>
                            </div>
                        </div>

                        <!-- <div class="money_data"  *ngIf="edit_data?.pre_cut_diamond > 0"> -->
                        <div class="money_data"  *ngIf="false">
                            <div style="display: flex;justify-content: center;">
                                <h4 style="margin-right: 1%;">匯率調整</h4>
                                <i class="fas fa-plus" style="cursor: pointer;align-content: center;color: cadetblue;" (click)="add_money()" *ngIf="money_data.length == 0 && outstatus == 0"></i>
                            </div>
                            <div style="display: flex;justify-content: center;">
                                <app-table-v2  *ngIf="money_data.length>0" [type]="1" [tcontent]="tcontent_money" [data]="money_data">
                                    <ng-template let-post #operation_dk>
                                        <div *ngIf="post.key == 'diamond'">
                                            <div *ngIf="post.val.diamond == null">全部</div>
                                            <div *ngIf="post.val.diamond != ''">{{post.val.diamond}}</div>
                                        </div>
                                        <div *ngIf="post.key == 'exchange_rate'">
                                            <div *ngIf="post.val.exchange_rate == 1">個人</div>
                                            <div *ngIf="post.val.exchange_rate == 2">經紀</div>
                                        </div>
                                        <div *ngIf="post.key == 'gg' && outstatus == 0">
                                            <a href="javascript:void(0)" title="刪除"  (click)="del(2,post.idx);">
                                                <i style="margin: 0 10px 0 0;" class="fas fa-trash"></i>
                                            </a>
                                            <a href="javascript:void(0)" title="編輯"  (click)="edit(post);">
                                                <i style="margin: 0 10px 0 0;" class="fas fa-file-signature"></i>
                                            </a>
                                        </div>
                                    </ng-template>
                                </app-table-v2>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="subnow=='9' && diamond_type == 1">
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">調整鑽石數</label>
                            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="diamond" placeholder="請輸入鑽石數">
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">調整月份</label>
                            <select class="form-control vlist" style="margin-bottom: 3%;"
                                *ngIf="diamod_month_list.length>1"
                                [(ngModel)]="diamod_month"
                            >
                                <option default disabled value="-2">請選擇調整月份</option>
                                <option *ngFor="let item of diamod_month_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">備註</label>
                            <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="diamondagenttextarea"></textarea>
                        </div>
                    </div>
                    <div *ngIf="subnow=='9' && diamond_type == 2">
                        <div class="user_edit_block form-group">
                            <button [ngClass]="range_status == 0?'btn-success':'btn-secondary'" (click)="range_status = 0" class="btn modalbtn" style="margin-right: 1%;">全部</button>
                            <button [ngClass]="range_status == 1?'btn-success':'btn-secondary'" (click)="range_status = 1" class="btn modalbtn">自訂</button>
                        </div>
                        <div class="user_edit_block form-group" *ngIf="range_status == 1">
                            <label class="col-sm-2 col-form-label custom">調整鑽石數</label>
                            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="diamond" placeholder="請輸入鑽石數">
                        </div>
                        <!-- <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">選擇類型</label>
                            <select class="form-control vlist"
                                *ngIf="diamod_month_list.length>1"
                                [(ngModel)]="diamod_type"
                            >
                            <option default disabled value="-2">請選擇類型</option>
                            <option *ngFor="let item of diamod_type_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div> -->
                        <!-- <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">調整月份</label>
                            <select class="form-control vlist" style="margin-bottom: 3%;"
                                *ngIf="diamod_month_list.length>1"
                                [(ngModel)]="diamod_month"
                            >
                            <option default disabled value="-2">請選擇調整月份</option>
                            <option *ngFor="let item of diamod_month_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div> -->
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label custom">備註</label>
                            <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="moneyagenttextarea"></textarea>
                        </div>
                    </div>
                </div>
                <!-- Modal footer -->

                <!--匯率調整和鑽石調整下方確認按鈕-->
                <div class="modal-footer" *ngIf="subnow=='9' && diamond_type > 0">

                    <button type="button"  (click)="checkcancel()"  class="btn btn-danger">取消</button>
                    <button type="button" *ngIf="diamond_type == 1" (click)="checksave(1)"    class="btn btn-primary">確認</button>
                    <button type="button" *ngIf="diamond_type == 2" (click)="checksave(2)"    class="btn btn-primary">確認</button>

                </div>

                <!--匯率設定下方確認按鈕-->
                <div class="modal-footer" *ngIf="subnow=='9' && diamond_type == 0">
                    <button type="button"  (click)="saverange()"    class="btn btn-primary"  data-dismiss="modal">保存</button>
                </div>

                <!--其他設定下方確認按鈕-->
                <div class="modal-footer"  *ngIf=" subnow!='9' ">
                    <button type="button" *ngIf="subnow=='0'||subnow=='3'" (click)="save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
                    <button type="button" *ngIf="subnow=='6'" (click)="serial_save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
                    <button type="button" *ngIf="subnow!='0' && subnow!='3' &&  subnow!='6' &&  subnow!='8'"    class="btn btn-primary" data-dismiss="modal">確認</button>
                    <button type="button" *ngIf="subnow=='0'||subnow=='3'"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                    <button type="button" *ngIf="subnow=='8'" (click)="accounting_memo_save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
                </div>
            </div>
        </div>
    </div>

    <!-- 6  -->
    <div *ngIf="now=='6'" style="text-align: center;">
        <h5>今日經紀上線人數 : {{serizedataTotal | number}}</h5>
        <h5>今日經紀未上線人數 : {{(all_nember - serizedataTotal - numBan) | number}}</h5>
        <h5>經紀全部人員人數 : {{all_nember | number}}</h5>
        <h5>今日經紀總收入 : {{serizedat3total | number}}</h5>
        <h5>停權人數 : {{numBan | number}}</h5>
        <h5>{{nowMonth}} 經紀全部總收入 : {{serizedata4total | number}}</h5>
        <h6>資料更新時間 : {{vendor_update_time}}</h6>

        <div>
            <button [ngClass]="enable_type == 0?'btn-success':'btn-secondary'"  (click)="enable_type = 0" class="btn modalbtn" style="margin-right: 2%;" (click)="this.init_list()">加入停權計算</button>
            <button [ngClass]="enable_type == 1?'btn-success':'btn-secondary'" (click)="enable_type = 1" class="btn modalbtn" (click)="this.init_list()">未加入停權計算</button>
        </div>
    </div>

    <div *ngIf="now=='6' && serizedata.length > 0 && isDesktop == true" style="display:flex;justify-content: space-around;">
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 30%;margin:10px"></highcharts-chart>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions2" style="display: block;width: 30%;margin:10px"></highcharts-chart>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions3" style="display: block;width: 30%;margin:10px"></highcharts-chart>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions4" style="display: block;width: 30%;margin:10px"></highcharts-chart>
    </div>

    <div *ngIf="now=='6' && serizedata.length > 0 && isDesktop == true" class="d-flex">
        <div class="row">
            <div class="col-6">
                <div class="row">
                    <div class="col border border-secondary rounded-lg p-2 m-1 bg-white">
                        <p class="d-flex justify-content-center font-weight-bold">⏱️ 每日上線時間經紀成員人數</p>
                        <div class="d-flex justify-content-center">
                            <app-table-v2 [type]="1"  [data]="serizedata" [tcontent]="tcontent" [highlightColor]="'#f2f2f2'" [highlightCondition]="true">
                                <ng-template let-post #operation_dk>
                                    <div *ngIf="post.key == 'sourcecount'">
                                        <a href="javascript:void(0)" (click)="handleClick(post.val,1)">{{post.val.sourcecount}}</a>
                                    </div>
                                </ng-template>
                            </app-table-v2>
                        </div>
                    </div>
                    <div class="col border border-secondary rounded-lg p-2 m-1 bg-white">
                        <p class="d-flex justify-content-center font-weight-bold">🈚 每日未上線經紀成員人數</p>
                        <div class="d-flex justify-content-center">
                            <app-table-v2 [type]="1"  [data]="serizedata2" [tcontent]="tcontent1x" [highlightColor]="'#f2f2f2'" [highlightCondition]="true">
                                <ng-template let-post #operation_dk>
                                    <div *ngIf="post.key == 'lineount'">
                                        <a href="javascript:void(0)" (click)="handleClick(post.val,2)">{{post.val.lineount}}</a>
                                    </div>
                                </ng-template>
                            </app-table-v2>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12 border border-secondary rounded-lg p-3 mt-1 bg-white shadow-sm">
                        <h5 class="font-weight-bold text-center mb-3">📝 設定目標</h5>
                        <div>
                            <!-- 滾動區域 -->
                            <div class="overflow-auto" style="max-height: 415px;">
                                <div class="vendor-list">
                                    <ng-container *ngFor="let item of all_vendor_list; let last = last; let first = first">
                                        <ng-container *ngIf="vid == '-1' || vid == item.id">
                                            <div class="row align-items-center vendor-item p-2 m-1 border rounded" [ngClass]="{'border-0': first && last}" style="border-color: rgba(23, 162, 184, 0.5) !important;">
                                                <!-- {{item|json}} -->
                                                <!-- 代理商名稱 + 設定按鈕 -->
                                                <div class="col-12 d-flex justify-content-between align-items-center mb-1">
                                                    <h5 class="vendor-name font-weight-bold m-0" style="font-family: Noto Sans TC, sans-serif !important;">{{ item.name }}</h5>
                                                    <div *ngIf="userPowerId == 5 || this.userPowerId == 6 || userPowerId == 13">
                                                        <button *ngIf="!item.isEditing" class="btn btn-info btn-sm" (click)="item.isEditing = true">設定</button>
                                                        <button *ngIf="item.isEditing" class="btn btn-success btn-sm" (click)="updateVendorTargets(item)">確認</button>
                                                        <button *ngIf="item.isEditing" class="btn btn-secondary btn-sm ml-1" (click)="item.isEditing = false">取消</button>
                                                    </div>
                                                </div>

                                                <!-- 分隔線 -->
                                                <div class="w-100 my-1 border-top"></div>

                                                <!-- 目標數值 -->
                                                <div class="col-6 target-section text-center">
                                                    <span class="font-weight-bold">📩 每日群發目標數:</span>
                                                    <ng-container *ngIf="item.isEditing; else viewMode1">
                                                        <input type="number" [(ngModel)]="item.daily_mass_message_target" class="form-control form-control-sm text-center">
                                                    </ng-container>
                                                    <ng-template #viewMode1>
                                                        <span class="font-weight-bold text-primary">{{ item.daily_mass_message_target }}</span>
                                                    </ng-template>
                                                </div>

                                                <!-- 分隔線 -->
                                                <!-- <div class="separator"></div> -->

                                                <div class="col-6 target-section text-center">
                                                    <span class="font-weight-bold">🌟 精選動態目標數:</span>
                                                    <ng-container *ngIf="item.isEditing; else viewMode2">
                                                        <input type="number" [(ngModel)]="item.featured_post_target" class="form-control form-control-sm text-center">
                                                    </ng-container>
                                                    <ng-template #viewMode2>
                                                        <span class="font-weight-bold text-primary">{{ item.featured_post_target }}</span>
                                                    </ng-template>
                                                </div>

                                                <!-- 目前數值與達成進度 -->
                                                <div class="col-6 target-section text-center mt-1">
                                                    <span class="font-weight-bold">🔄 目前群發數:</span>
                                                    <span class="font-weight-bold" [ngClass]="{'text-success': item.mass_sending_count >= item.daily_mass_message_target, 'text-danger': item.mass_sending_count < item.daily_mass_message_target}">{{ item.mass_sending_count || 0 }}</span>
                                                    <span class="badge px-2 d-flex align-items-center pb-1" [ngClass]="{'badge-success': item.mass_sending_count >= item.daily_mass_message_target, 'badge-danger': item.mass_sending_count < item.daily_mass_message_target}">
                                                        {{ item.mass_sending_count >= item.daily_mass_message_target ? '+' : '' }}
                                                        {{ item.mass_sending_count - item.daily_mass_message_target }}
                                                    </span>
                                                </div>

                                                <div class="col-6 target-section text-center mt-1">
                                                    <span class="font-weight-bold">📢 目前精選動態數:</span>
                                                    <span class="font-weight-bold" [ngClass]="{'text-success': item.featured_post_count >= item.featured_post_target, 'text-danger': item.featured_post_count < item.featured_post_target}">{{ item.featured_post_count || 0 }}</span>
                                                    <span class="badge px-2 d-flex align-items-center pb-1" [ngClass]="{'badge-success': item.featured_post_count >= item.featured_post_target, 'badge-danger': item.featured_post_count < item.featured_post_target}">
                                                        {{ item.featured_post_count >= item.featured_post_target ? '+' : '' }}
                                                        {{ item.featured_post_count - item.featured_post_target }}
                                                    </span>
                                                </div>

                                                <!-- 分隔線 -->
                                                <div class="w-100 my-2 border-top"></div>

                                                <!-- 每月目標業績額 -->
                                                <div class="col-6 target-section text-center">
                                                    <span class="font-weight-bold">💰 每月目標業績額:</span>
                                                    <ng-container *ngIf="item.isEditing; else viewMode4">
                                                        <input type="number" [(ngModel)]="item.monthly_target" class="form-control form-control-sm text-center">
                                                    </ng-container>
                                                    <ng-template #viewMode4>
                                                        <span class="font-weight-bold text-primary">{{ item.monthly_target }}</span>
                                                    </ng-template>
                                                </div>

                                                <!-- 招募數目標 -->
                                                <div class="col-6 target-section text-center">
                                                    <span class="font-weight-bold">🎯 每月招募數目標:</span>
                                                    <ng-container *ngIf="item.isEditing; else viewMode3">
                                                        <input type="number" [(ngModel)]="item.recruitment_target" class="form-control form-control-sm text-center">
                                                    </ng-container>
                                                    <ng-template #viewMode3>
                                                        <span class="font-weight-bold text-primary">{{ item.recruitment_target }}</span>
                                                    </ng-template>
                                                </div>

                                                <!-- 目前目標業績額 -->
                                                <div class="col-6 target-section text-center mt-1">
                                                    <span class="font-weight-bold">📊 目前業績額:</span>
                                                    <span class="font-weight-bold"
                                                        [ngClass]="{'text-success': item.total_income >= item.monthly_target,
                                                                    'text-danger': item.total_income < item.monthly_target}">
                                                        {{ item.total_income || 0 }}
                                                    </span>
                                                    <span class="badge px-2 d-flex align-items-center pb-1"
                                                        [ngClass]="{'badge-success': item.total_income >= item.monthly_target,
                                                                    'badge-danger': item.total_income < item.monthly_target}">
                                                        {{ item.total_income >= item.monthly_target ? '+' : '' }}
                                                        {{ item.total_income - item.monthly_target }}
                                                    </span>
                                                </div>

                                                <!-- 目前招募數 -->
                                                <div class="col-6 target-section text-center mt-1">
                                                    <span class="font-weight-bold">📋 目前招募數:</span>
                                                    <span class="font-weight-bold"
                                                        [ngClass]="{'text-success': item.recruitment_count >= item.recruitment_target,
                                                                    'text-danger': item.recruitment_count < item.recruitment_target}">
                                                        {{ item.recruitment_count || 0 }}
                                                    </span>
                                                    <span class="badge px-2 d-flex align-items-center pb-1"
                                                        [ngClass]="{'badge-success': item.recruitment_count >= item.recruitment_target,
                                                                    'badge-danger': item.recruitment_count < item.recruitment_target}">
                                                        {{ item.recruitment_count >= item.recruitment_target ? '+' : '' }}
                                                        {{ item.recruitment_count - item.recruitment_target }}
                                                    </span>
                                                </div>

                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 border border-secondary rounded-lg p-3 mt-1 bg-white shadow-sm" *ngIf="vid != '-1'">
                        <h5 class="font-weight-bold text-center mb-3">📊 歷史設定數值</h5>
                        <div class="d-flex justify-content-center w-100" style="max-height: 220px; overflow-x: auto;">
                            <div class="w-100">
                                <app-table-v2 [type]="2" [tcontent]="historySettingTcontent"
                                              [data]="historySettingContent"
                                              [highlightColor]="'#ffe6fb'"
                                              [highlightCondition]="true"
                                              style="min-width: 100%;">
                                    <ng-template let-post #operation_dk>
                                    </ng-template>
                                </app-table-v2>

                                <!-- <app-pagnation (callback)="callback($event)" [data]="historySettingPageObjStr"></app-pagnation> -->
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="col-6">
                <div class="row">
                    <div class="col border border-secondary rounded p-2 m-1 bg-white">
                        <p class="d-flex justify-content-center font-weight-bold">💰 每日經紀成員收入</p>
                        <p class="d-flex justify-content-center" *ngIf="serizedata3.length == 0">無資料</p>
                        <div class="d-flex justify-content-center">
                            <app-table-v2 [type]="1"  [data]="serizedata3" [tcontent]="tcontent2" *ngIf="serizedata3.length>0" [highlightColor]="'#f2f2f2'" [highlightCondition]="true">
                                <ng-template let-post #operation_dk>
                                    <div *ngIf="post.key == 'sourcecount' && post.idx != 1">
                                       <a href="javascript:void(0)" (click)="handleClick2(post.idx,1)">{{post.val.sourcecount | number}}</a>
                                    </div>
                                    <div *ngIf="post.key == 'sourcecount' && post.idx == 1">
                                        {{post.val.sourcecount | number}}
                                     </div>
                                </ng-template>
                            </app-table-v2>
                        </div>
                    </div>
                    <div class="col border border-secondary rounded p-2 m-1 bg-white">
                        <p class="d-flex justify-content-center font-weight-bold">💰 各月經紀成員收入</p>
                        <p class="d-flex justify-content-center" *ngIf="serizedata4.length == 0">無資料</p>
                        <div class="d-flex justify-content-center align-items-center mb-2">
                            <label class="text-nowrap" for="start" style="margin-right: 10px;">請選擇月份 : </label>
                            <input type="month" id="start" name="start" min="2018-03" [(ngModel)]="nowMonth" (change)="this.init_list()" />
                        </div>
                        <div class="d-flex justify-content-center">
                            <app-table-v2 [type]="1"  [data]="serizedata4" [tcontent]="tcontent2x" *ngIf="serizedata4.length>0" [highlightColor]="'#f2f2f2'" [highlightCondition]="true">
                                <ng-template let-post #operation_dk>
                                    <div *ngIf="post.key == 'sourcecount' && post.idx != 1">
                                        <a href="javascript:void(0)" (click)="handleClick2(post.idx,2)">{{post.val.sourcecount | number}}</a>
                                    </div>
                                    <div *ngIf="post.key == 'sourcecount' && post.idx == 1">
                                        {{post.val.sourcecount | number}}
                                    </div>
                                </ng-template>
                            </app-table-v2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 px-0" *ngIf="vid == '-1'">
                <div class="border border-secondary rounded p-0 bg-white ">
                    <h5 class="d-flex justify-content-center font-weight-bold mt-3">📈 每日經紀成員變化圖</h5>
                    <!-- 下拉選單 -->
                    <div class="d-flex justify-content-end align-items-center mt-2 mr-5">
                        <label for="daySelect" class="mr-2">選擇查詢天數：</label>
                        <select id="daySelect" class="form-control w-auto" [(ngModel)]="selectedDays" (change)="init_list()">
                            <option *ngFor="let day of availableDays" [value]="day">{{ day }} 天</option>
                        </select>
                    </div>
                    <div class="d-flex justify-content-center">
                        <highcharts-chart class="d-flex justify-content-center" [Highcharts]="Highcharts"  [(update)]="vendorEmpNumUpdateFlag" [options]="vendorEmpNumlineOptions" style="display: block;width: 90%;"></highcharts-chart>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div *ngIf="now=='6' && serizedata.length > 0 && isDesktop == false">
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 100%;margin:10px"></highcharts-chart>
        <div>
            <div class="row d-flex justify-content-center">
                <p>每日上線時間經紀成員人數</p>
            </div>

            <div class="row d-flex justify-content-center">
                <app-table-v2 [type]="1"  [data]="serizedata" [tcontent]="tcontent">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'sourcecount'">
                            <a href="javascript:void(0)" (click)="handleClick(post.val,1)">{{post.val.sourcecount}}</a>
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
        </div>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions2" style="display: block;width: 100%;margin:10px"></highcharts-chart>
        <div>
            <div class="row d-flex justify-content-center">
                <p>每日未上線經紀成員人數</p>
            </div>
            <div class="row d-flex justify-content-center">
                <app-table-v2 [type]="1"  [data]="serizedata2" [tcontent]="tcontent1x">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'lineount'">
                            <a href="javascript:void(0)" (click)="handleClick(post.val,2)">{{post.val.lineount}}</a>
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
        </div>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions3" style="display: block;width: 100%;margin:10px"></highcharts-chart>
        <div>
            <div class="row d-flex justify-content-center">
                <p>每日經紀成員收入</p>
                <p *ngIf="serizedata3.length == 0">無資料</p>
            </div>

            <div class="row d-flex justify-content-center">
                <app-table-v2 [type]="1"  [data]="serizedata3" [tcontent]="tcontent2" *ngIf="serizedata3.length>0">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'sourcecount'">
                        <a href="javascript:void(0)" (click)="handleClick2(post.idx,1)">{{post.val.sourcecount}}</a>
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
        </div>
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions4" style="display: block;width: 100%;margin:10px"></highcharts-chart>
        <div >
            <div class="d-flex justify-content-center">
                <label for="start" style="margin-right: 10px;">請選擇月份 : </label>
                <input type="month" id="start" name="start" min="2018-03" [(ngModel)]="nowMonth" (change)="this.init_list()" />
            </div>
            <div class="d-flex justify-content-center">
                <p>各月經紀成員收入</p>
                <p *ngIf="serizedata4.length == 0">無資料</p>
            </div>
            <div class="row d-flex justify-content-center">
                <app-table-v2 [type]="1"  [data]="serizedata4" [tcontent]="tcontent2x" *ngIf="serizedata4.length>0">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'sourcecount'">
                            <a href="javascript:void(0)" (click)="handleClick2(post.idx,2)">{{post.val.sourcecount}}</a>
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
        </div>

        <!-- 手機版目標設定 (isDesktop == false) -->
        <div class="col-12 border border-secondary rounded-lg p-3 mt-1 bg-white shadow-sm" *ngIf="now=='6' && !isDesktop">
            <h5 class="font-weight-bold text-center mb-3">📝 設定目標</h5>

            <div class="overflow-auto" style="max-height: 415px;">
                <div class="vendor-list">
                    <ng-container *ngFor="let item of all_vendor_list">
                        <ng-container *ngIf="vid == '-1' || vid == item.id">

                            <!-- 手機版：每個代理商獨立成卡片 -->
                            <div class="card mb-3 shadow-sm">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h6 class="m-0">{{ item.name }}</h6>
                                    <div class="d-flex justify-content-end">
                                        <button *ngIf="!item.isEditing" class="btn btn-sm btn-info" (click)="item.isEditing = true">設定</button>
                                        <button *ngIf="item.isEditing" class="btn btn-sm btn-success" (click)="updateVendorTargets(item)">確認</button>
                                        <button *ngIf="item.isEditing" class="btn btn-sm btn-secondary ml-1" (click)="item.isEditing = false">取消</button>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <!-- 目標數值 -->
                                    <div class="row text-center">
                                        <div class="col-6">
                                            <span class="font-weight-bold">📩 每日群發目標:</span>
                                            <ng-container *ngIf="item.isEditing; else viewMode1">
                                                <input type="number" [(ngModel)]="item.daily_mass_message_target" class="form-control form-control-sm text-center">
                                            </ng-container>
                                            <ng-template #viewMode1>
                                                <span class="font-weight-bold text-primary ml-3">{{ item.daily_mass_message_target }}</span>
                                            </ng-template>
                                        </div>

                                        <div class="col-6">
                                            <span class="font-weight-bold">🌟 精選動態目標:</span>
                                            <ng-container *ngIf="item.isEditing; else viewMode2">
                                                <input type="number" [(ngModel)]="item.featured_post_target" class="form-control form-control-sm text-center">
                                            </ng-container>
                                            <ng-template #viewMode2>
                                                <span class="font-weight-bold text-primary ml-3">{{ item.featured_post_target }}</span>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <hr>

                                    <!-- 目前數值與達成進度 -->
                                    <div class="row text-center">
                                        <div class="col-6 ">
                                            <div class="d-flex justify-content-around">
                                                <span class="font-weight-bold">🔄 目前群發數:</span>
                                                <span class="font-weight-bold" [ngClass]="{'text-success': item.mass_sending_count >= item.daily_mass_message_target, 'text-danger': item.mass_sending_count < item.daily_mass_message_target}">
                                                    {{ item.mass_sending_count || 0 }}
                                                </span>
                                                <span class="badge px-2"
                                                    [ngClass]="{'badge-success': item.mass_sending_count >= item.daily_mass_message_target, 'badge-danger': item.mass_sending_count < item.daily_mass_message_target}">
                                                    {{ item.mass_sending_count >= item.daily_mass_message_target ? '+' : '' }}
                                                    {{ item.mass_sending_count - item.daily_mass_message_target }}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex justify-content-around">
                                                <span class="font-weight-bold">📢 目前精選動態數:</span>
                                                <span class="font-weight-bold" [ngClass]="{'text-success': item.featured_post_count >= item.featured_post_target, 'text-danger': item.featured_post_count < item.featured_post_target}">
                                                    {{ item.featured_post_count || 0 }}
                                                </span>
                                                <span class="badge px-2 "
                                                    [ngClass]="{'badge-success': item.featured_post_count >= item.featured_post_target, 'badge-danger': item.featured_post_count < item.featured_post_target}">
                                                    {{ item.featured_post_count >= item.featured_post_target ? '+' : '' }}
                                                    {{ item.featured_post_count - item.featured_post_target }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <!-- 目標業績與招募數 -->
                                    <div class="row text-center">
                                        <div class="col-6">
                                            <span class="font-weight-bold">💰 每月目標業績額:</span>
                                            <ng-container *ngIf="item.isEditing; else viewMode4">
                                                <input type="number" [(ngModel)]="item.monthly_target" class="form-control form-control-sm text-center">
                                            </ng-container>
                                            <ng-template #viewMode4>
                                                <span class="font-weight-bold text-primary ml-3">{{ item.monthly_target }}</span>
                                            </ng-template>
                                        </div>

                                        <div class="col-6">
                                            <span class="font-weight-bold">🎯 每月招募目標:</span>
                                            <ng-container *ngIf="item.isEditing; else viewMode3">
                                                <input type="number" [(ngModel)]="item.recruitment_target" class="form-control form-control-sm text-center">
                                            </ng-container>
                                            <ng-template #viewMode3>
                                                <span class="font-weight-bold text-primary ml-3">{{ item.recruitment_target }}</span>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <hr>

                                    <!-- 目前業績額與招募數 -->
                                    <div class="row text-center">

                                        <div class="col-6">
                                            <div class="d-flex justify-content-around">
                                                <span class="font-weight-bold">📊 目前業績額:</span>
                                                <span class="font-weight-bold" [ngClass]="{'text-success': item.total_income >= item.monthly_target, 'text-danger': item.total_income < item.monthly_target}">
                                                    {{ item.total_income || 0 }}
                                                </span>
                                                <span class="badge px-2 d-flex align-items-center text-center"
                                                    [ngClass]="{'badge-success': item.total_income >= item.monthly_target, 'badge-danger': item.total_income < item.monthly_target}">
                                                    {{ item.total_income >= item.monthly_target ? '+' : '' }}
                                                    {{ item.total_income - item.monthly_target }}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex justify-content-around">
                                                <span class="font-weight-bold">📋 目前招募數:</span>
                                                <span class="font-weight-bold" [ngClass]="{'text-success': item.recruitment_count >= item.recruitment_target, 'text-danger': item.recruitment_count < item.recruitment_target}">
                                                    {{ item.recruitment_count || 0 }}
                                                </span>
                                                <span class="badge px-2 d-flex align-items-center"
                                                    [ngClass]="{'badge-success': item.recruitment_count >= item.recruitment_target, 'badge-danger': item.recruitment_count < item.recruitment_target}">
                                                    {{ item.recruitment_count >= item.recruitment_target ? '+' : '' }}
                                                    {{ item.recruitment_count - item.recruitment_target }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="col-12 border border-secondary rounded-lg p-3 mt-1 bg-white shadow-sm" *ngIf="vid != '-1'">
            <h5 class="font-weight-bold text-center mb-3">📊 歷史設定數值</h5>
            <div class="d-flex justify-content-center w-100" style="max-height: 350px; overflow-x: auto;">
                <div class="w-100">
                    <app-table-v2 [type]="1" [tcontent]="historySettingTcontent"
                                  [data]="historySettingContent"
                                  [highlightColor]="'#ffe6fb'"
                                  [highlightCondition]="true"
                                  style="min-width: 100%;">
                        <ng-template let-post #operation_dk>
                        </ng-template>
                    </app-table-v2>

                    <!-- <app-pagnation (callback)="callback($event)" [data]="historySettingPageObjStr"></app-pagnation> -->
                </div>
            </div>
        </div>

        <div class="col-12 px-0 mt-2" *ngIf="vid == '-1'">
            <div class="border border-secondary rounded p-0 bg-white ">
                <h5 class="d-flex justify-content-center font-weight-bold mt-3">📈 每日經紀成員變化圖</h5>
                <!-- 下拉選單 -->
                <div class="d-flex justify-content-end align-items-center mt-2 mr-5">
                    <label for="daySelect" class="mr-2">選擇查詢天數：</label>
                    <select id="daySelect" class="form-control w-auto" [(ngModel)]="selectedDays" (change)="init_list()">
                        <option *ngFor="let day of availableDays" [value]="day">{{ day }} 天</option>
                    </select>
                </div>
                <div class="d-flex justify-content-center">
                    <highcharts-chart class="d-flex justify-content-center" [Highcharts]="Highcharts"  [(update)]="vendorEmpNumUpdateFlag" [options]="vendorEmpNumlineOptions" style="display: block;width: 90%;"></highcharts-chart>
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="now=='6'">

        <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
            <li *ngFor="let item of sub_menu_list;let i = index" class="nav-item"  style="cursor:pointer" (click)="sub_choose(item.id)">
                <span [ngClass]="sublist_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
            </li>
        </ul>

        <div *ngIf="sublist_now == '9' || sublist_now == '0'">
            <div style="margin-bottom: 1%;">
                <app-date [type]="true"  [time]="times" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
                <input type="text" [(ngModel)]="search_model" class="form-control fix_input search_inp" placeholder="可輸入名稱搜尋用戶" (keyup.enter)="init_list()">
                <app-pushmessage [select_num] = "alls_user_id.length" (pushMessageEmt)="handlePushMessageEmtSelected($event)"></app-pushmessage>
            </div>

            <app-table-v2 [type]="1"  [data]="data" [tcontent]="incomecontent" *ngIf="data.length>0" (sortdata)="handlesortdata($event)">
                <ng-template let-post #operation_dk>
                    <div *ngIf="post.key == 'is_enable'">
                        <div *ngIf="post.val.is_enable == '0'">
                            停權
                        </div>
                        <div *ngIf="post.val.is_enable == '1'">
                            正常
                        </div>
                    </div>
                    <div *ngIf="post.key == 'status'">
                        <div *ngIf="post.val.status == '1'">
                            啟用
                        </div>
                        <div *ngIf="post.val.status == '-1'">
                            關閉變回正常用戶
                        </div>
                        <div *ngIf="post.val.status == '0'">
                            鎖定無法提領
                        </div>
                    </div>
                </ng-template>
            </app-table-v2>
            <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
        </div>

        <div *ngIf="sublist_now == '1'">
            <div  style="width: 240px;">
                <input type="text"
                    class="form-control"
                    ngxDaterangepickerMd
                    [(ngModel)]="time"
                    [autoApply]="true"
                    [ranges]="ranges" [alwaysShowCalendars]="true"
                    [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                    [opens]="'right'"
                    [minDate]="time.minDate"
                    [maxDate]='time.maxDate'
                    (change)="onRangeSelected($event)"
                (blur)="onDateTyped($event)">
            </div>

            <r-table [data]="posts_input"  (callback)="init_list()">
                <ng-template let-post #operation_dk>
                    <span *ngIf="post.key=='name'">
                        <div *ngIf="vendor_list.length>=1">
                            <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                        </div>
                        <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                    </span>
                </ng-template>
                <ng-template let-post #operation_mb>
                    <span *ngIf="post.key=='name'">
                        <div *ngIf="vendor_list.length>=1">
                            <app-userandactive  [post]="data[post.idx]"></app-userandactive>
                        </div>
                        <div *ngIf="vendor_list.length<1">{{data[post.idx].name}}</div>
                    </span>
                </ng-template>
            </r-table>

            <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>

        </div>

    </div>


     <!-- 6  -->


    <!--8-->

    <div *ngIf="now=='8'">

        <select class="form-control vlist" style="margin-bottom: 3%;"
            *ngIf="rank_announce_list.length>1"
            [(ngModel)]="rank_announce_select"
            (change)="pageobj.page=0;rank_list()"
        >
            <option *ngFor="let item of rank_announce_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <app-table-v2 [type]="1"  [data]="rank_data" [tcontent]="rankcontent" *ngIf="rank_data.length>0"></app-table-v2>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>

    </div>

    <!--8-->


    <!--9-->

    <div *ngIf="now=='9'">

        <div style="margin-bottom: 1%;">
            <app-date [type]="true"  [time]="times" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
            <input type="text" [(ngModel)]="search_model" class="form-control fix_input search_inp" placeholder="可輸入名稱搜尋用戶" (keyup.enter)="init_list()">
        </div>

        <app-table-v2 [type]="1"  [data]="data" [tcontent]="incomecontent" *ngIf="data.length>0" (sortdata)="handlesortdata($event)"></app-table-v2>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>

    </div>

    <!--9-->

    <!--10-->

    <div *ngIf="now=='10'">

        <input type="text" [(ngModel)]="search_model" class="form-control fix_input search_inp" placeholder="可輸入名稱搜尋用戶" (keyup.enter)="init_list()">

        <app-table-v2 [type]="1"  [data]="data" [tcontent]="withdrawalcontent">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'withdrawal_month'">
                    <select class="form-control vlist" [(ngModel)]="post.val.withdrawal_month" (change)="check_action(post.val);" *ngIf="isYearSelectable(post.val.withdrawal_month)  == true">
                        <option disabled value="">請選擇月份</option>
                        <option *ngFor="let item of withdrawal_month_option" [ngValue]="item.id">{{item.name}}</option>
                    </select>

                    <div  *ngIf="isYearSelectable(data[post.idx].withdrawal_month) == false" >
                        {{data[post.idx].withdrawal_month}}
                    </div>

                </div>

                <div *ngIf="post.key == 'action'">
                    <button [ngClass]="post.val.action == 1?'btn-primary':'btn-secondary'" class="btn"  (click)="post.val.action = 1;check_action(post.val);">匯款</button>
                    <button [ngClass]="post.val.action == 2?'btn-primary':'btn-secondary'" class="btn" style="margin-left: 2%;"  (click)="post.val.action = 2;check_action(post.val);">領現</button>
                </div>

                <div *ngIf="post.key == 'status'">
                    <div *ngIf="post.val.status == '0'">
                        未結算
                    </div>
                    <div *ngIf="post.val.status == '1'">
                        已結算
                    </div>
                    <div *ngIf="post.val.status == '2'">
                        結算失敗
                    </div>
                </div>

                <div *ngIf="post.key == 'actual_withdrawal_status'">
                    <button  *ngIf="post.val.actual_withdrawal_status == 0" [ngClass]="post.val.actual_withdrawal_status == 0 || post.val.actual_withdrawal_status == 0?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(post.val, 0)" class="btn" style="margin-right:1%">尚未付款</button>
                    <button  *ngIf="(post.val.actual_withdrawal_status == 0 || post.val.actual_withdrawal_status == 1 || post.val.actual_withdrawal_status == 2)" [ngClass]="post.val.actual_withdrawal_status == 1 || post.val.actual_withdrawal_status == 1?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(post.val, 1)" class="btn" style="margin-right:1%">付款成功</button>
                    <button  *ngIf="(post.val.actual_withdrawal_status == 0 || post.val.actual_withdrawal_status == 2)" [ngClass]="post.val.actual_withdrawal_status == 2 || post.val.actual_withdrawal_status == 2?'btn-primary':'btn-secondary'" (click)="set_withdrawal_status(post.val, 2)" class="btn" style="margin-right:1%">付款失敗</button>
                </div>

                <div *ngIf="post.key == 'gg'">
                    <div style="display:flex">
                        <a href="javascript:void(0)" title="點我設定"  (click)="edit_pro(post.val)">
                            <i style="margin-right:10px" class="fas fa-solid fa-pen" ></i>
                        </a>
                    </div>
                </div>

                <!-- <div *ngIf="post.key == 'save'">
                    <button class='btn btn-info' (click)="save_withdrawal(post.val)"  *ngIf="isYearSelectable(post.val.withdrawal_month)  == true">儲存</button>
                </div> -->
            </ng-template>
        </app-table-v2>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>

    </div>

    <!--10-->

    <!--11-->

    <div *ngIf="now=='11'">
        <button data-toggle="modal" (click)="get_default();" data-target=".bd-example1-modal-xl" class="btn btn-primary mb-3">新增人員</button>
        <!-- <app-table-v2 [type]="1"  [data]="data" [tcontent]="tcontent" *ngIf="data.length>0" (sortdata)="handlesortdata($event)">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'status'">
                    <div *ngIf="post.val.status == -1">對方拒絕</div>
                    <div *ngIf="post.val.status == 0">取消</div>
                    <div *ngIf="post.val.status == 1">邀請中</div>
                </div>
                <div *ngIf="post.key == 'gg'">
                    <div *ngIf="post.val.status == 1">
                        <button  class="btn btn-danger" (click)="cancel_user(post.val);">取消邀請</button>
                    </div>
                </div>
            </ng-template>
        </app-table-v2>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation> -->
    </div>

    <!--11-->

    <ng-template #yourModalContent2 let-modal>
        <div class="modal-header">

            <h4 class="modal-title"  *ngIf="this.detailnember_type == 1">每日經紀成員收入</h4>
            <h4 class="modal-title"  *ngIf="this.detailnember_type == 2">每月經紀成員收入</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="serizedetaildata.length > 0">
                <app-table-v2 [type]="1"  [data]="serizedetaildata" [tcontent]="tcontent1"></app-table-v2>
            </div>
            <div *ngIf="serizedetaildata.length == 0">
                <p>目前無資料</p>
            </div>
        </div>

        <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation>

    </ng-template>

    <ng-template #yourModalContent3 let-modal>
        <div class="modal-header">
            <h4 class="modal-title" >領現資料填寫</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label custom">姓名</label>
                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_profile.id_name">
            </div>
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label custom">身分證字號</label>
                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_profile.id_number">
            </div>
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label custom">戶籍地址</label>
                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_profile.permanent_addr">
            </div>
            <!-- <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label custom">備註</label>
                <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_profile.memo">
            </div> -->
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label custom">低收入戶二代健保資格</label>
                <button [ngClass]="edit_profile.healthy_fee_cn == 0?'btn-success':'btn-secondary'" (click)="edit_profile.healthy_fee_cn = 0" class="btn modalbtn">是</button>
                <button [ngClass]="edit_profile.healthy_fee_cn == 1?'btn-success':'btn-secondary'" (click)="edit_profile.healthy_fee_cn = 1" class="btn modalbtn" style="margin-left: 2%;">否</button>
            </div>
            <div  class="user_edit_block form-group" style="display: flex;">
                <label class="col-sm-2 col-form-label custom">身分證正面</label>
                <app-img-cropper [editData]="edit_profile.id_card" (imageUpload)="handleImageUpload($event,0)"></app-img-cropper>
            </div>
            <div class="card card_fix" *ngIf="edit_profile.id_card != ''" style="margin-top: 2%;">
                <img loading="lazy" style="height:15rem;margin-top: 2%;" src="{{edit_profile.id_card}}" class="card-img-top" alt="...">
                <div class="card-body">
                    <h5 class="card-title">身分證正面</h5>
                    <p class="card-text"></p>
                </div>
            </div>
            <div  class="user_edit_block form-group" style="display: flex;">
                <label class="col-sm-2 col-form-label custom">身分證背面</label>
                <app-img-cropper [editData]="edit_profile.id_cardback" (imageUpload)="handleImageUpload($event,1)"></app-img-cropper>
            </div>

            <div class="card card_fix" *ngIf="edit_profile.id_cardback != ''"  style="margin-top: 2%;">
                <img loading="lazy" style="height:15rem" src="{{edit_profile.id_cardback}}" class="card-img-top" alt="...">
                <div class="card-body">
                    <h5 class="card-title">身分證背面</h5>
                    <p class="card-text"></p>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="save_set();modal.dismiss('Cross click')">確認</button>
            <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">取消</button>
        </div>
    </ng-template>

    <ng-template #yourModalContent let-modal>
        <div class="modal-header">
            <h4 class="modal-title" *ngIf="detailnember_type > 0">每日經紀成員收入</h4>
            <h4 class="modal-title" *ngIf="detail_type == 1">每日上線時間經紀人員列表</h4>
            <h4 class="modal-title" *ngIf="detail_type == 2">每日未上線經紀人員列表</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="serizedetaildata.length > 0">
                <app-table-v2 [type]="1"  [data]="serizedetaildata" [tcontent]="tcontent1">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'login_times_front'">
                            {{ post.val.login_times_front / 60 | number:'1.2-2' }}
                        </div>
                        <div *ngIf="post.key == 'last_singin_date'">
                            {{ post.val.last_singin_date }}
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
            <div *ngIf="serizedetaildata.length == 0">
                <p>目前無資料</p>
            </div>
        </div>

        <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation>

    </ng-template>

</div>
<app-spinner [loading]="loading"></app-spinner>




<ng-template #brokerModal let-modal>
    <div class="modal-header">
        經紀人員新增
        <button type="button" class="close" (click) = "cancel_user_identy()">&times;</button>
    </div>
    <div class="modal-body">
        <div>
            <!-- 主按鈕 -->
            <!-- 動態生成的 input 和搜尋按鈕 -->
            <div *ngFor="let field of inputFields; let i = index" class="dynamic-field">
                <div style="display:flex;flex-wrap:wrap;gap:10px">
                    <input type="number" [(ngModel)]="field.country_value" placeholder="請輸入國別碼" class="dynamic-input"  style="width: 130px;" />
                    <input type="number" [(ngModel)]="field.value" placeholder="請輸入人員電話" class="dynamic-input phone-input" />
                    <button (click)="searchuser(field.value, i ,field.country_value)" class="search-button">確認該用戶</button>
                    <!-- <button (click)="removeInputField(i)" class="remove-button">移除 -</button> -->
                </div>
                <div *ngIf="(field.userItem?.identity == '3' || field.userItem?.identity == '6' || field.userItem?.identity == '99') && field.userItem?.id > '0'" style="margin-right: 2%;">
                    <hr>
                    該用戶已加入經紀
                </div>
            </div>
            <div class="card-grid">
                <div *ngFor="let field of add_inputFields; let i = index" class="cardsad">
                    <div class="avatar" (click)="removeInputField(i)" style="cursor: pointer;">
                        <img loading="lazy" [src]="field.profile_pic" alt="{{ field.name }}"/>
                    </div>
                    <div class="info">
                        <div class="name">{{ field.name }}</div>
                        <div class="phone">{{ field.phone }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary"  (click) = "add_user_identy()">新增</button>
        <button type="button" class="btn btn-danger" (click) = "cancel_user_identy()">取消</button>
    </div>
</ng-template>
